import React, { useState, ChangeEvent, useEffect, useRef } from "react";
import { ISingleRegRequest } from "../../../typings/interfaces/Requests/SingleRegRequest";
import {
  SaveSingleRegistration,
  getBatchNumbers,
  getFCRegNos,
  getMicrochipRegistrations,
  checkLicenceExistance,
  checkPremiseCodeExistance,
  getScientificNames,
  getHarvestDetailsByPremiseCode,
  DownloadBulkRegistrationTemplate,
  SaveBulkRegistrationForPets,
  PremiseCodeDetails,
  SaveBulkRegistrationForFish,
} from "../../../api/apimethods";
import { IBulkRegRequest } from "../../../typings/interfaces/Requests/BulkRegRequest";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import * as XLSX from "xlsx";
import FileSaver from "file-saver";
import ReCAPTCHA from "react-google-recaptcha";
import { countryMobileCodes } from "../../../scripts/countryMobileCodes";
import fetchCountryOptions from "../../../scripts/countryOptions";
import { IcountryOptions } from "../../../typings/models/CountryOption";
import ExcelJS from "exceljs";
import { IHarvestApplicationResponseModel } from "../../../typings/models/HarvestApplicationResponseModel";
import Upload from "../../Upload/Upload";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Holiday } from "../../../typings/models/Holiday";
import fetchHolidaysMaster from "../../../scripts/holidaysMaster";
import { AppContext, defaultAppContextData } from "../../../services/appData";
import { useConfig } from "../../../context/ConfigProvider";
import { useAuthService, useContextService } from "../../../services";
import { addDays } from "date-fns";
import { IProductCodeMasterModel } from "../../../typings/models/ProductCodeMasterModel";
import { ICodeMasterModel } from "../../../typings/models/CodeMasterModel";
import { NotifyType } from "../../../utils/app-config";
import { notify } from "../../../utils";
import Loader from "../../../components/molecules/Loader";
import { IPetRegistraionBulkRegRequest } from "../../../typings/interfaces/Requests/PetRegistrationBulkRequestData";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { fi } from "date-fns/locale";
import { setRecaptchaRef } from "../../../api/builder";

interface TabPhillProfileProps {
  RegistrationType: any;
}

interface Option {
  value: string;
  label: string;
}
interface UploadedFile {
  name: string;
  date: string;
  file: File;
}
const TabPhillProfile: React.FC<TabPhillProfileProps> = ({
  RegistrationType,
}) => {
  const cfg = useConfig();
  const arowanaScientificName: string =
    cfg.DRAGONFISH_SCIENTIFICNAME ??
    "SCLEROPAGES FORMOSUS (ASIAN AROWANA) [FFO1AW1DRGF]";

  const { getContextValueFromStorage } = useContextService();
  const [contextData] = useState(() =>
    getContextValueFromStorage(defaultAppContextData)
  );
  const user = contextData.user;

  let mode = 1;
  const inputHolidayRef = useRef(true);
  const inputUserRef = useRef(true);
  const { message } = notify();
  const [errorMessage, setErrorMessage] = useState("");
  const [sRegistrationType, setsRegistrationType] = useState<number>(0);
  const [registrationMode, setRegistrationMode] = useState<string>("passport");
  const [regName, setregName] = useState<string>("Bird Single Registration");
  const [ssalutation, setsSalutation] = useState<number>(0);
  const [sapplicantName, setsApplicantName] = useState("");
  const [sNRIC, setsNRIC] = useState("");
  const [sSourceofFish, setsSourceofFish] = useState("");
  const [sUEN, setsUEN] = useState("");
  const [scompanyName, setsCompanyName] = useState("");
  const [slicenceNumber, setsLicenceNumber] = useState("");
  const [spremiseCode, setsPremiseCode] = useState("");
  const [uploadedFiles, setUploadedFiles] = useState<UploadedFile[]>([]);
  const [secondFile, setSecondFile] = useState<File | null>(null);
  const [premiseCodeNoShowError, setPremiseCodeNoShowError] = useState(true);
  const [
    premiseCodeHarvestDetailNoShowError,
    setPremiseCodeHarvestDetailNoShowError,
  ] = useState(true);
  const [sorganizationAddress, setsOrganizationAddress] = useState("1");
  const [sorganizationAddress2, setsOrganizationAddress2] = useState("0");
  const [sorganizationAddress3, setsOrganizationAddress3] = useState("");
  const [sorganizationAddress4, setsOrganizationAddress4] = useState("");
  const [sorganizationAddress5, setsOrganizationAddress5] = useState("");
  const [sorganizationAddress6, setsOrganizationAddress6] = useState("");
  const [sorganizationAddress7, setsOrganizationAddress7] = useState("");
  const [sorganizationAddress8, setsOrganizationAddress8] = useState("");
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [sorganizationAddress9, setsOrganizationAddress9] = useState("");
  const [sorganizationAddress10, setsOrganizationAddress10] = useState("");
  const [smobileNo, setsMobileNo] = useState("");
  const [smobilecode, setsMobileCode] = useState("+65");
  const [semail, setsEmail] = useState("");
  const [isFromRegistrationLink, setIsFromRegistrationLink] = useState(false);
  const [sfcRegistrationNo, setsFCRegistrationNo] = useState("");
  //const [stypeOfBird, setsTypeOfBird] = useState("");
  const [scountryOrigin, setsCountryOfOrigin] = useState("");
  const [sHatchDate, setHatchDate] = useState<Date | null>(null);
  const [isValidDate, setisValidDate] = useState(true);

  const [sscientificName, setsScientificName] = useState<Option | null>(null);
  const [sscientificNameString, setsScientificNameString] = useState("");
  const [scitesAppendixNo, setsCitesAppendixNo] = useState<number>(0);
  const [slegRingNo, setsLegRingNo] = useState("");
  const [sforeignCITESPermitNo, setsForeignCITESPermitNo] = useState("");
  const [sbulkFarmCode, setsbulkFarmCode] = useState("");
  const [sTypeofTag, setsTypeofTag] = useState<number>(0);
  const [sTagNumber, setsTagNumber] = useState("");
  const [sVarietyofFish, setsVarietyofFish] = useState<number>(0);
  const [sLengthofFish, setsLengthofFish] = useState<number>(0);
  const [sBatchNumber, setsBatchNumber] = useState("");
  const [sRegisteredQuantityinBatch, setsRegisteredQuantityinBatch] =
    useState(0);
  const [sHarvestDate, setsHarvestDate] = useState<Date | null>(null);
  const [sParentMicrochip, setsParentMicrochip] = useState("");
  const [sRemarks, setsRemarks] = useState("");
  const [sMicrochipNumber, setsMicrochipNumber] = useState("");
  const [defaultCountryId, setDefaultCountryId] = useState("");

  const [showBird, setShowBird] = useState(false);
  const [showCrocodile, setShowCrocodile] = useState(false);
  const [showDragonFish, setShowDragonFish] = useState(false);
  const [validEmail, setValidEmail] = useState(true);
  const [submitted, setSubmitted] = useState(false);
  const [checkboxChecked, setCheckboxChecked] = useState(false);
  const [salutationSelected, setSalutationSelected] = useState(false);
  const recaptchaRef = useRef<ReCAPTCHA>(null);
  const site_Key: string = cfg.REACT_APP_SITE_KEY ?? "";
  const currentDate = new Date();
  currentDate.setMonth(currentDate.getMonth() + 2);
  const minDate = currentDate; //.toISOString().split("T")[0];
  const [floorNoShowError, setfloorNoShowError] = useState(true);
  const [unitNoShowError, setunitNoShowError] = useState(true);
  const [blockNoShowError, setblockNoShowError] = useState(true);
  const [postalCodeShowError, setpostalCodeShowError] = useState(true);
  const [validMobileNo, setValidMobileNo] = useState(true);
  const [isCaptchaValid, setIsCaptchaValid] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [showTooltip, setShowTooltip] = useState(false);
  const [countries, setCountries] = useState<IcountryOptions[]>([]);
  const [batchNumbers, setBatchNumbers] = useState<IcountryOptions[]>([]);
  const [fcRegNos, setFCRegNos] = useState<ICodeMasterModel[]>([]);
  const [harvestData, setHarvestData] = useState<
    IHarvestApplicationResponseModel[]
  >([]);
  const [showUpload, setShowUpload] = useState(false);
  const [licenceNumberNoShowError, setLicenceNumberNoShowError] =
    useState(true);
  const [uenNoShowError, setUENNoShowError] = useState(true);
  const [batchNumberNoShowError, setBatchNumberNoShowError] = useState(true);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [disableScientificName, setDisableScientificName] = useState(false);
  const [isSubmiting, setSubmiting] = useState(false);
  const [scientificNames, setScientificNames] = useState<Option[]>([]);
  const [expiryDate, setExpiryDate] = useState<Date | null>(null);
  const [allScientificNames, setAllScientificNames] = useState<
    IProductCodeMasterModel[]
  >([]);
  const [holidays, setHolidays] = useState<Holiday[]>([]);
  const [isValidScientificName, setisValidScientificName] = useState(true);
  const [viewMode, setViewMode] = useState(false);
  useEffect(() => {
    setRecaptchaRef(recaptchaRef); // 🔗 give Axios access to the reCAPTCHA
  }, []);
  let navigate = useNavigate();
  const location = useLocation();
  let regId = location.state?.id;
  let editMode = location.state?.mode;
  let regType = location.state?.RegistrationType;
  let type = "";

  const inputData = {
    regName,
    sSourceofFish,
    ssalutation,
    sapplicantName,
    sUEN,
    sNRIC,
    scompanyName,
    slicenceNumber,
    spremiseCode,
    sorganizationAddress,
    sorganizationAddress2,
    sorganizationAddress3,
    sorganizationAddress4,
    sorganizationAddress5,
    sorganizationAddress6,
    sorganizationAddress7,
    sorganizationAddress8,
    sorganizationAddress9,
    sorganizationAddress10,
    smobileNo,
    smobilecode,
    semail,
    sfcRegistrationNo,
    scountryOrigin,
    sscientificNameString,
    scitesAppendixNo,
    slegRingNo,
    sforeignCITESPermitNo,
    sTypeofTag,
    sTagNumber,
    sVarietyofFish,
    sLengthofFish,
    sBatchNumber,
    sRegisteredQuantityinBatch,
    sHarvestDate,
    sHatchDate,
    sParentMicrochip,
    sRemarks,
    sMicrochipNumber,
    expiryDate,
  };
const handleSelect = (opt: Option | null) => {
    // Keep the object if you need it elsewhere
    console.log("Selected option:", opt);
  const next =
    opt ? scientificNames.find(o => String(o.value) === String(opt.value)) ?? opt : null;
    console.log("Normalized option:", next);
  setsScientificName(next);
  // Source of truth for rendering:
  setsScientificNameString(next?.value != null ? String(next.value) : "");
};
  const isWeekend = (date: any) => {
    const day = date.getDay();
    return day === 0 || day === 6; // Sunday (0) or Saturday (6)
  };

  const isHoliday = (date: any) => {
    const dateString = date.toString().split("T");
    return holidays.some(
      (holiday) =>
        // holiday.holidayDate.split("T").includes(dateString)
        date.toDateString() === new Date(holiday.holidayDate).toDateString()
    );
  };

  const fixTimezoneOffset = (date: Date | null): Date | null => {
    if (!date) return null;
    return new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  };

  const getTimezoneOffset = (date: Date): Date | null => {
    const newDate = new Date(date);
    const userTimezoneOffset = Math.abs(newDate.getTimezoneOffset() * 60000);
    return new Date(newDate.getTime() - userTimezoneOffset);
  };
  const handleMouseEnter = () => {
    setShowTooltip(true);
  };
  const handleMouseLeave = () => {
    setShowTooltip(false);
  };
  const blockNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setsOrganizationAddress3(value);
    if (value === "") {
      setblockNoShowError(true);
    } else {
      setblockNoShowError(true);
    }
  };
  const postalCodeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[0-9]+$/;
    setsOrganizationAddress9(value);
    if (pattern.test(value)) {
      setpostalCodeShowError(true);
    } else {
      if (value === "") {
        setpostalCodeShowError(true);
      } else {
        setpostalCodeShowError(false);
      }
    }
  };

  const unitNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[a-zA-Z0-9\s]+$/;

    if (pattern.test(value)) {
      setsOrganizationAddress7(value);
      setunitNoShowError(true);
    } else {
      if (value === "") {
        setsOrganizationAddress7(value);
        setunitNoShowError(true);
      } else {
        setunitNoShowError(false);
      }
    }
  };

  const floorNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[a-zA-Z0-9\s]+$/;

    if (pattern.test(value)) {
      setsOrganizationAddress6(value);
      setfloorNoShowError(true);
    } else {
      if (value === "") {
        setsOrganizationAddress6(value);
        setfloorNoShowError(true);
      } else {
        setfloorNoShowError(false);
      }
    }
  };
  useEffect(() => {
    if (spremiseCode) {
      const fetchPremiseDetails = async () => {
        try {
          const response = await PremiseCodeDetails(spremiseCode);

          if (response.data) {
            setsOrganizationAddress3(response.data.blockHouseNumber || "");
            setsOrganizationAddress5(response.data.streetRoadName || "");
            setsOrganizationAddress6(response.data.floorNumber || "");
            setsOrganizationAddress7(response.data.unitNumber || "");
            setsOrganizationAddress8(response.data.buildingName || "");
            const postalCodeWithoutSpaces = response.data.postalCode.replace(
              /\s/g,
              ""
            );
            setsOrganizationAddress9(postalCodeWithoutSpaces || "");

            postalCodeHandler({
              target: {
                value: postalCodeWithoutSpaces || "",
              } as EventTarget & HTMLInputElement,
            } as ChangeEvent<HTMLInputElement>);
            blockNoHandler({
              target: { value: response.data.blockHouseNumber || "" },
            } as ChangeEvent<HTMLInputElement>);

            setpostalCodeShowError(true);
            setblockNoShowError(true);
            setunitNoShowError(true);
            setfloorNoShowError(true);
          }
        } catch (error) {
          console.error("Failed to fetch premise details", error);
        }
      };

      fetchPremiseDetails();
    }
  }, [spremiseCode]);
  const mobileNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[0-9]+$/;

    if (pattern.test(value)) {
      setsMobileNo(value);
      if (value.length < 8) {
        setValidMobileNo(false);
      } else {
        setValidMobileNo(true);
      }
    } else {
      if (value === "") {
        setsMobileNo(value);
        setValidMobileNo(true);
      } else {
        setValidMobileNo(false);
      }
    }
  };

  useEffect(() => {
    if (inputUserRef.current) {
      inputUserRef.current = false;
      if (regId === undefined || user !== undefined) {
        if (user.uen != undefined) setsUEN(user.uen);
        if (user.companyName != undefined) setsCompanyName(user.companyName);
        if (user.name != undefined) setsApplicantName(user.name);
        if (user.idNo != undefined) setsNRIC(user.idNo);
        if (user.contactNo != undefined) {
          setsMobileCode(user.contactNo.substring(0, 3));
          setsMobileNo(user.contactNo.substring(3));
        }
        if (user.email != undefined) setsEmail(user.email);
        if (user.registeredAddresses != undefined) {
          setsOrganizationAddress("1");
          setsOrganizationAddress9(user.registeredAddresses?.[0]?.postalCode);
          setsOrganizationAddress3(user.registeredAddresses?.[0]?.blockHouseNo);
          setsOrganizationAddress5(user.registeredAddresses?.[0]?.streetName);
          setsOrganizationAddress6(user.registeredAddresses?.[0]?.floorLevel);
          setsOrganizationAddress7(user.registeredAddresses?.[0]?.unit);
          setsOrganizationAddress8(user.registeredAddresses?.[0]?.buildingName);
        }
      }
    }
    if (regId !== undefined) {
      try {
        const fetchDataToEdit = async () => {
          var response = null;
          response = await getMicrochipRegistrations(
            "",
            sRegistrationType,
            regId
          );
          if (response.data && response.data.length > 0) {
            if (editMode === "view") {
              setViewMode(true);
              setDisableSubmit(true);
            }
            if (response.data[0].uen != undefined) {
              setsUEN(response.data[0].uen);
            }
            if (response.data[0].companyName != undefined) {
              setsCompanyName(response.data[0].companyName);
            }
            if (response.data[0].salutation != undefined) {
              setsSalutation(response.data[0].salutation);
            }
            if (response.data[0].name != undefined)
              setsApplicantName(response.data[0].name);
            if (response.data[0].nric != undefined)
              setsNRIC(response.data[0].nric);
            if (response.data[0].mobileNoCode != undefined)
              setsMobileCode(response.data[0].mobileNoCode);
            if (response.data[0].mobileNo != undefined)
              setsMobileNo(response.data[0].mobileNo);
            if (response.data[0].email != undefined)
              setsEmail(response.data[0].email);
            if (response.data[0].addressType != undefined)
              setsOrganizationAddress(response.data[0].addressType);
            if (response.data[0].typeofPremises != undefined)
              setsOrganizationAddress2(response.data[0].typeofPremises);
            if (response.data[0].blockHouseNumber != undefined)
              setsOrganizationAddress3(response.data[0].blockHouseNumber);
            if (response.data[0].streetName != undefined)
              setsOrganizationAddress5(response.data[0].streetName);
            if (response.data[0].floorNumber != undefined)
              setsOrganizationAddress6(response.data[0].floorNumber);
            if (response.data[0].unitNumber != undefined)
              setsOrganizationAddress7(response.data[0].unitNumber);
            if (response.data[0].buildingName != undefined)
              setsOrganizationAddress8(response.data[0].buildingName);
            if (response.data[0].postalCode != undefined)
              setsOrganizationAddress9(response.data[0].postalCode);
            if (response.data[0].country != undefined)
              setsOrganizationAddress10(response.data[0].country);
            if (response.data[0].fcRegistrationNo != undefined)
              setsFCRegistrationNo(response.data[0].fcRegistrationNo);
            if (response.data[0].fcRegistrationNoLook != undefined)
              setsFCRegistrationNo(response.data[0].fcRegistrationNoLook);
            if (response.data[0].countryOrigin != undefined)
              setsCountryOfOrigin(response.data[0].countryOrigin);
            if (response.data[0].citesAppendixNo != undefined)
              setsCitesAppendixNo(response.data[0].citesAppendixNo);
            if (response.data[0].scientificName != undefined) {
              var scientificValue = response.data[0].scientificName;
              filterScientificNames(
                response.data[0].citesAppendixNo.toString()
              );
              var scientificName = scientificNames.find(
                (option) => option.value === scientificValue
              );
              if (scientificName != undefined)
                setsScientificName(scientificName);
            }
            if (response.data[0].hatchDate != undefined)
              setHatchDate(new Date(response.data[0].hatchDate));
            if (response.data[0].harvestDate != undefined) {
              setsHarvestDate(new Date(response.data[0].harvestDate));
            }
            if (response.data[0].foreignCITESPermitNo != undefined)
              setsForeignCITESPermitNo(response.data[0].foreignCITESPermitNo);

            if (response.data[0].farmCode != undefined)
              setsbulkFarmCode(response.data[0].farmCode);

            if (response.data[0].legRingNo != undefined) {
              setsLegRingNo(response.data[0].legRingNo);
            }
            if (response.data[0].typeofTag != undefined)
              setsTypeofTag(response.data[0].typeofTag);
            if (response.data[0].tagNumber != undefined)
              setsTagNumber(response.data[0].tagNumber);
            if (response.data[0].sourceofFish != undefined)
              setsSourceofFish(response.data[0].sourceofFish);
            if (response.data[0].varietyofFish != undefined)
              setsVarietyofFish(response.data[0].varietyofFish);
            if (response.data[0].lengthofFish != undefined)
              setsLengthofFish(response.data[0].lengthofFish);
            if (response.data[0].batchNumber != undefined)
              setsBatchNumber(response.data[0].batchNumber);
            if (response.data[0].registeredQuantityinBatch != undefined)
              setsRegisteredQuantityinBatch(
                response.data[0].registeredQuantityinBatch
              );
            if (response.data[0].parentMicrochip != undefined)
              setsParentMicrochip(response.data[0].parentMicrochip);
            if (response.data[0].microchipNumber != undefined)
              setsMicrochipNumber(response.data[0].microchipNumber);
            if (response.data[0].remarks != undefined)
              setsRemarks(response.data[0].remarks);
            if (response.data[0].licenceNumber != undefined) {
              {
                var licenceNumber = response.data[0].licenceNumber;
                setsLicenceNumber(licenceNumber);
                var batchNumber = "";
                var sourceofFish = "";
                if (response.data[0].batchNumber != undefined) {
                  batchNumber = response.data[0].batchNumber;
                }
                if (response.data[0].sourceofFish != undefined)
                  sourceofFish = response.data[0].sourceofFish;
                licenceNumberChange(licenceNumber, sourceofFish, batchNumber);
              }
            }
          } else {
            // API call failed
          }
          setCountries(countries);
          setIsLoading(false);
        };
        fetchDataToEdit();
      } catch (error) {
        setIsLoading(false);
      }
    }
  }, [regId]);

  useEffect(() => {
    if (inputHolidayRef.current) {
      inputHolidayRef.current = false;
      const fetchHolidaysData = async () => {
        const holidaysData = await fetchHolidaysMaster();
        setHolidays(holidaysData);
      };

      fetchHolidaysData();
    }
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const countries = await fetchCountryOptions();
      setCountries(countries);
      setIsLoading(false);
      const defaultCountry = countries.find(
        (option) => option.label === "Singapore"
      )?.value;
      if (defaultCountry !== undefined) {
        setsCountryOfOrigin(defaultCountry);
        setDefaultCountryId(defaultCountry);
        setsOrganizationAddress10(defaultCountry);
      }
    };
    fetchData();

    const fetchFCRegNos = async () => {
      // const fcRegNos = await fetchFCRegNos();
      try {
        const response = await getFCRegNos();
        // Process the response data and create the country options array
        if (response.data) {
          let fcRegNoOptions = response.data;
          setFCRegNos(fcRegNoOptions);
        }
      } catch (error) {
        console.error("Error fetching countries:", error);
        return [];
      }
      setIsLoading(false);
    };
    fetchFCRegNos();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const countries = await fetchCountryOptions();
      setCountries(countries);
      setIsLoading(false);
    };
    fetchData();
    if (location.state?.from !== "/application-registration") {
      let RegType = "Birds";
      if (
        RegistrationType !== null &&
        RegistrationType !== undefined &&
        RegistrationType.RegistrationType !== undefined
      ) {
        RegType = RegistrationType.RegistrationType.RegistrationType;
      }
      if (
        RegistrationType === "DragonFish" ||
        (RegistrationType !== null &&
          RegistrationType !== undefined &&
          RegistrationType.RegistrationType === "DragonFish") ||
        RegType === "DragonFish" ||
        regType === 3
      ) {
        setsRegistrationType(3);
        setsCitesAppendixNo(1);
        setShowDragonFish(true);
        setShowCrocodile(false);
        setShowBird(false);
        type = "DragonFish";
      } else if (
        RegistrationType === "Crocodile" ||
        (RegistrationType !== null &&
          RegistrationType !== undefined &&
          RegistrationType.RegistrationType === "Crocodile") ||
        RegType === "Crocodile" ||
        regType === 2
      ) {
        setsRegistrationType(2);
        setShowDragonFish(false);
        setShowCrocodile(true);
        setShowBird(false);
        type = "Crocodile";
      } else {
        setsRegistrationType(1);
        setShowDragonFish(false);
        setShowCrocodile(false);
        setShowBird(true);
        type = "Birds";
      }
    }
  }, [RegistrationType, location.state]);

  useEffect(() => {
    if (location.state?.from === "/application-registration") {
      setIsFromRegistrationLink(true);
      setsRegistrationType(3);
      setShowDragonFish(true);
      setsCitesAppendixNo(1);
      setsSourceofFish("1");
      setShowCrocodile(false);
      setShowBird(false);
      type = "DragonFish";
    }
  }, [location.state]);
  useEffect(() => {
    // const scientificNames = async () => {
    //   var response = null;
    //   var category = "Birds";
    //   if (sRegistrationType === 1) category = "Birds";
    //   else if (sRegistrationType === 2) category = "Crocodile";
    //   else if (sRegistrationType === 3) category = "DragonFish";
    //   response = await getScientificNames(type);
    //   if (response.data) {
    //     const data = response.data;

    //     // Assuming your API response has an array of options
    //     var apiOptions: Option[] = data.map((item: any) => ({
    //       value: item.id.toString(),
    //       label: item.scientificNameCommonName,
    //     }));

    //     if (type === "DragonFish") {
    //       apiOptions = apiOptions.filter(
    //         (opt) => opt.label === arowanaScientificName
    //       );
    //     }
    //     setScientificNames(apiOptions);
    //   }
    // };
    mscientificNames();
  }, []);

  const mscientificNames = async (citesAppendixNo?: string) => {
    try {
      let response = null;
      let category = "Birds";

      if (sRegistrationType === 1) category = "Birds";
      else if (sRegistrationType === 2) category = "Crocodile";
      else if (sRegistrationType === 3) category = "DragonFish";

      if (type !== "") category = type;

      setDisableScientificName(true);

      response = await getScientificNames(category);

      if (response.data) {
        let data = response.data;

        setAllScientificNames(data);

        if (
          category !== "DragonFish" &&
          citesAppendixNo != null &&
          citesAppendixNo !== undefined
        ) {
          data = data.filter((opt) => opt.citesAppendixNo === citesAppendixNo);
        }

        let apiOptions: Option[] = data.map((item: any) => ({
          value: item.id.toString(),
          label: item.scientificNameCommonName,
        }));

        if (category === "DragonFish") {
          apiOptions = apiOptions.filter(
            (opt) => opt.label === arowanaScientificName
          );
        }

        setScientificNames(apiOptions);
      } else {
        throw new Error("No data received.");
      }
    } catch (error) {
      console.error("Error fetching scientific names:", error);
      message(
        NotifyType.Error,
        "Failed to fetch scientific names. Please try again."
      );
    } finally {
      setDisableScientificName(false);
    }
  };

  const handlePremiseCodeBlur = async (
    event: React.FocusEvent<HTMLInputElement>
  ) => {
    var response = await checkPremiseCodeExistance(event.target.value);
    if (response.data) {
      premiseCodeChange(event.target.value, sSourceofFish);
      setPremiseCodeNoShowError(true);
      setDisableSubmit(false);
    } else {
      setDisableSubmit(true);
      setPremiseCodeNoShowError(false);
      setBatchNumberNoShowError(true);
    }
  };

  const handleLicenceNumberBlur = async (
    event: React.FocusEvent<HTMLInputElement>
  ) => {
    licenceNumberChange(event.target.value, sSourceofFish);
  };

  const handleLicenceNumberBlurNew = async (
    event: React.FocusEvent<HTMLInputElement>
  ) => {
    var licenceNumber = event.target.value;
    if (licenceNumber?.length > 0) {
      var response = await checkLicenceExistance(licenceNumber);
      if (!response.data) {
        setLicenceNumberNoShowError(false);
        setDisableSubmit(true);
      } else {
        setDisableSubmit(false);
        setLicenceNumberNoShowError(true);
      }
    } else {
      setLicenceNumberNoShowError(true);
    }
  };

  const licenceNumberChange = async (
    licenceNumber: string,
    sourceofFish: string,
    batchNumber?: string
  ) => {
    try {
      if (licenceNumber !== "") {
        let disable = false;
        setLicenceNumberNoShowError(true);
        setBatchNumberNoShowError(true);
        setUENNoShowError(true);
        const response = await getBatchNumbers(licenceNumber);

        if (response.data) {
          const { harvestDetails, uen } = response.data;

          if (harvestDetails != null) {
            if (sourceofFish === "1") {
              if (harvestDetails.length) {
                setHarvestData(harvestDetails);

                const filteredHarvestData = harvestDetails.filter(
                  (batch) =>
                    new Date(batch.harvestDate) <= addDays(new Date(), -60) &&
                    batch.remainingQuantityinBatch > 0 &&
                    new Date(batch.expiryDate) > new Date()
                );

                const options = filteredHarvestData.map(
                  (harvestDetails: IHarvestApplicationResponseModel) => ({
                    value: harvestDetails.harvestDetailsId,
                    label: harvestDetails.batchNumber,
                  })
                );

                if (options.length > 0) {
                  setBatchNumbers(options);

                  if (batchNumber !== null && batchNumber !== undefined) {
                    setsBatchNumber(batchNumber);
                  } else {
                    setsBatchNumber(options[0].value);
                    FillRegisteredQty(options[0].value, filteredHarvestData);
                  }

                  setBatchNumberNoShowError(true);
                  disable = false;
                } else {
                  console.warn("No valid harvest data found.");
                  setBatchNumberNoShowError(false);
                  disable = true;
                }
              } else {
                console.warn("No harvest details available.");
                setBatchNumberNoShowError(false);
                disable = true;
              }
            }
          } else {
            console.warn("No licence details found.");
            setLicenceNumberNoShowError(false);
            disable = true;
          }

          if (batchNumber === null && uen !== undefined) {
            if (uen !== sUEN) {
              setUENNoShowError(false);
              disable = true;
            } else {
              setUENNoShowError(true);
            }
          }

          setDisableSubmit(disable);
        } else {
          console.warn("No data.");
          setLicenceNumberNoShowError(false);
          setDisableSubmit(true);
        }
      }
    } catch (error) {
      console.error("Error in licenceNumberChange:", error);
      setLicenceNumberNoShowError(false);
      setBatchNumberNoShowError(false);
      setUENNoShowError(false);
      setDisableSubmit(true);

      message(
        NotifyType.Error,
        "An error occurred while fetching licence details. Please try again."
      );
    }
  };

  const premiseCodeChange = async (
    premiseCode: string,
    sourceofFish: string
  ) => {
    try {
      let disable = false;
      const response = await getHarvestDetailsByPremiseCode(premiseCode);
      if (response.data) {
        const { harvestDetails, uen } = response.data;
        setPremiseCodeHarvestDetailNoShowError(true);
        setBatchNumberNoShowError(true);
        if (harvestDetails != null) {
          if (sourceofFish === "1") {
            if (harvestDetails.length) {
              setHarvestData(harvestDetails);

              const filteredHarvestData = harvestDetails.filter(
                (batch) =>
                  batch.remainingQuantityinBatch > 0 &&
                  new Date(batch.expiryDate) > new Date()
              );

              const options = filteredHarvestData.map(
                (harvestDetails: IHarvestApplicationResponseModel) => ({
                  value: harvestDetails.harvestDetailsId,
                  label: harvestDetails.batchNumber,
                })
              );

              if (options.length > 0) {
                setBatchNumbers(options);
                setsBatchNumber(options[0].value);
                FillRegisteredQty(options[0].value, filteredHarvestData);

                // if (batchNumber !== null && batchNumber !== undefined) {
                //   setsBatchNumber(batchNumber);
                // } else {
                //   setsBatchNumber(options[0].value);
                //   FillRegisteredQty(options[0].value, filteredHarvestData);
                // }

                setBatchNumberNoShowError(true);
              } else {
                console.warn("No valid harvest data found.");
                setBatchNumberNoShowError(false);
                setsBatchNumber("");
                setsRegisteredQuantityinBatch(0);
                setsHarvestDate(null);
                setsParentMicrochip("");
                setsVarietyofFish(Number(0));
              }
            } else {
              console.warn("No harvest details available.");
              setBatchNumberNoShowError(false);
              setsBatchNumber("");
              setsRegisteredQuantityinBatch(0);
              setsHarvestDate(null);
              setsParentMicrochip("");
              setsVarietyofFish(Number(0));
            }
          }
        } else {
          console.warn("No matching details found for entered premise code.");
          setPremiseCodeHarvestDetailNoShowError(false);
          setsBatchNumber("");
          setsRegisteredQuantityinBatch(0);
          setsHarvestDate(null);
          setsParentMicrochip("");
          setsVarietyofFish(Number(0));
        }

        // if (batchNumber === null && uen !== undefined) {
        //   if (uen !== sUEN) {
        //     setUENNoShowError(false);
        //     disable = true;
        //   } else {
        //     setUENNoShowError(true);
        //   }
        // }

        setDisableSubmit(disable);
      } else {
        console.warn("No data.");
        setPremiseCodeHarvestDetailNoShowError(false);
        setDisableSubmit(true);
      }
    } catch (error) {
      console.error("Error in premiseCodeChange:", error);
      //setLicenceNumberNoShowError(false);
      //setBatchNumberNoShowError(false);
      //setUENNoShowError(false);
      setDisableSubmit(true);

      message(
        NotifyType.Error,
        "An error occurred while fetching harvest details. Please try again."
      );
    }
  };

  const handleUENBlur = async (event: React.FocusEvent<HTMLInputElement>) => {
    try {
      if (slicenceNumber !== "") {
        let disable = false;
        setLicenceNumberNoShowError(true);
        setBatchNumberNoShowError(true);
        setUENNoShowError(true);

        const response = await getBatchNumbers(slicenceNumber);

        if (response.data) {
          // if (
          //   response.data.harvestDetails != null &&
          //   response.data.harvestDetails.length
          // ) {
          //   setHarvestData(response.data.harvestDetails);
          //   var options = response.data.harvestDetails.map(
          //     (harvestDetails: IHarvestApplicationResponseModel) => ({
          //       value: harvestDetails.batchNumber,
          //       label: harvestDetails.batchNumber,
          //     })
          //   );
          //   setBatchNumbers(options);
          //   setsBatchNumber(options[0].value);
          //   FillRegisteredQty(options[0].value, response.data.harvestDetails);
          //   setBatchNumberNoShowError(true);
          //   disable = false;
          // } else {

          //   setBatchNumberNoShowError(false);
          //   disable = true;
          // }

          if (response.data.uen != undefined) {
            const uen = response.data.uen;
            if (uen !== sUEN) {
              setUENNoShowError(false);
              disable = true;
            } else {
              setUENNoShowError(true);
              if (!disable) disable = false;
            }
          } else {
            setUENNoShowError(false);
          }
          setDisableSubmit(disable);
        } else {
          console.warn("No data.");
          setLicenceNumberNoShowError(false);
          setDisableSubmit(true);
        }
      }
    } catch (error) {
      console.error("Error in handleUENBlur:", error);

      setLicenceNumberNoShowError(false);
      setBatchNumberNoShowError(false);
      setUENNoShowError(false);
      setDisableSubmit(true);

      message(
        NotifyType.Error,
        "An error occurred while fetching UEN details. Please try again."
      );
    }
  };

  const handleCountryChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setsOrganizationAddress10(event.target.value);
  };

  const handleCountryOfOriginChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setsCountryOfOrigin(event.target.value);
  };

  const handleCitesAppendixChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setsCitesAppendixNo(Number(event.target.value));
    filterScientificNames(event.target.value);
  };

  const filterScientificNames = (citesAppendixNo: string) => {
    setsScientificName(null);
    var data = allScientificNames.filter(
      (opt) => opt.citesAppendixNo == citesAppendixNo
    );

    // Assuming your API response has an array of options
    var apiOptions: Option[] = data.map((item: any) => ({
      value: item.id.toString(),
      label: item.scientificNameCommonName,
    }));

    setScientificNames(apiOptions);
  };

  //Date validation
  //const currentDates = new Date();
  currentDate.setDate(currentDate.getDate() - 1); // Set it to today
  const maxdate = currentDate; //.toISOString().split("T")[0];

  const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedDate = event.target.value;
    const selectedDateObj = new Date(selectedDate);
    const maxdateObj = new Date(maxdate);
    if (maxdateObj >= selectedDateObj) {
      // setHatchDate(selectedDate);
      setisValidDate(true);
    } else {
      event.preventDefault();
      setisValidDate(false);
      // setHatchDate("");
    }
  };

  const handleBatchNumberChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    var batchNo = event.target.value;
    setsBatchNumber(batchNo);
    FillRegisteredQty(batchNo, harvestData);
  };

  const FillRegisteredQty = (
    batchNo: string,
    harvestData: IHarvestApplicationResponseModel[]
  ) => {
    var filteredData = harvestData.filter(
      (h) => h.harvestDetailsId === batchNo
    );
    if (filteredData && filteredData.length > 0) {
      var fishQty = filteredData[0].remainingQuantityinBatch;
      var harvestDate = filteredData[0].harvestDate;
      var parentMicrochip = filteredData[0].brooderMicrochipNumberString;
      var variety = filteredData[0].variety;
      var expDate = filteredData[0].expiryDate;
      setsRegisteredQuantityinBatch(fishQty);
      setsHarvestDate(new Date(harvestDate));
      setsParentMicrochip(parentMicrochip);
      setsVarietyofFish(Number(variety));
      setExpiryDate(expDate);
    }
  };

  if (isLoading) {
    return <Loader />;
  }

  const handleDownload = async () => {
    if (!checkboxChecked) {
      message(NotifyType.Error, "Please confirm the declaration checkbox.");
      return;
    }
    if (!isCaptchaValid) {
      message(NotifyType.Error, "Please complete the reCAPTCHA verification.");
      return;
    }
    try {
      if(isFromRegistrationLink)
      {
        const response = await DownloadBulkRegistrationTemplate(7);
        const data = await response.data;
  
        if (data != null) {
          let sliceSize = 1024;
          let byteCharacters = atob(data.data);
          let bytesLength = byteCharacters.length;
          let slicesCount = Math.ceil(bytesLength / sliceSize);
          let byteArrays = new Array(slicesCount);
  
          for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
            let begin = sliceIndex * sliceSize;
            let end = Math.min(begin + sliceSize, bytesLength);
            let bytes = new Array(end - begin);
            for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
              bytes[i] = byteCharacters[offset].charCodeAt(0);
            }
            byteArrays[sliceIndex] = new Uint8Array(bytes);
          }
  
          FileSaver.saveAs(
            new Blob(byteArrays, {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            }),
            data.message
          );
        } else {
          setIsCaptchaValid(false);
          recaptchaRef?.current?.reset();
          message(NotifyType.Error, "No document found. Please try again.");
        }
      }
      else{
      setShowUpload(true);
      const data: { LegRingNumber: string, HatchDate: string , Source: string}[] = [
        {
          // SequenceNumber: 1,
          LegRingNumber: "",
          HatchDate: "",
          Source: ""
        },
      ];

      let filename = "Leg Ring Numbers for Birds";

      generateExcelFileContent([data], filename);
      let path = `/application-registration`;
      navigate(path, { state: { RegistrationType, bulkRequestData } });
      }
      
    } catch (error) {
      console.error("Download failed:", error);
      message(
        NotifyType.Error,
        "Failed to download the file. Please try again."
      );
    }
  };
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];

    if (file) {
      const allowedTypes = [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel",
      ];

      if (!allowedTypes.includes(file.type)) {
        message(
          NotifyType.Error,
          "Invalid file type. Please upload a .xls or .xlsx file."
        );
        return;
      }

      if (file.size > 5 * 1024 * 1024) {
        message(
          NotifyType.Error,
          "File size exceeds 5 MB. Please upload a smaller file."
        );
        return;
      }

      setSelectedFile(file);
    }
  };

  const handleFileProcessed = async (
    bulkRegRequest: IPetRegistraionBulkRegRequest
  ) => {
    try {
      setIsLoading(true);
      const response = await SaveBulkRegistrationForFish(bulkRegRequest);

      if (response.data.data) {
        setIsLoading(false);
        message(NotifyType.Success, "File Uploaded Successfully");
      } else {
        setIsLoading(false);
        setIsCaptchaValid(false);
        recaptchaRef?.current?.reset();
        const errorMessage = response.data.message;
        message(NotifyType.Error, errorMessage);
      }
    } catch (error) {
      setIsLoading(false);
      setIsCaptchaValid(false);
      recaptchaRef?.current?.reset();
      console.error("API Error:", error);
      message(NotifyType.Error, "An error occurred while processing the file.");
    }
  };
  const arrayBufferToBase64 = (buffer: ArrayBuffer) => {
    let binary = "";
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  };
  const handleUpload = () => {
    if (!checkboxChecked) {
      message(NotifyType.Error, "Please confirm the declaration checkbox.");
      return;
    }
    if (!isCaptchaValid) {
      message(NotifyType.Error, "Please complete the reCAPTCHA verification.");
      return;
    }
    if (!selectedFile) {
      message(NotifyType.Error, "Please select a file first.");
      return;
    }
    const validExtensions = [".xls", ".xlsx"];
    const fileExtension = selectedFile.name
      .slice(selectedFile.name.lastIndexOf("."))
      .toLowerCase();

    if (!validExtensions.includes(fileExtension)) {
      message(
        NotifyType.Error,
        "Invalid file type. Please upload an Excel file."
      );
      return;
    }

    const reader = new FileReader();

    reader.onload = (e) => {
      if (e.target?.result) {
        const data = new Uint8Array(e.target.result as ArrayBuffer);
        const base64data = arrayBufferToBase64(e.target.result as ArrayBuffer);

        const uploadedDocument = {
          fileName: selectedFile.name,
          file: base64data,
        };

        const bulkRequestData: IPetRegistraionBulkRegRequest = {
          userInformation: {
            name: user?.name,
            idType: user?.idType,
            idNo: user?.idNo,
            email: user?.email,
            contactNo: user?.contactNo,
            companyName: user?.companyName,
            uen: user?.uen,
            registeredAddress: user?.registeredAddresses?.[0],
          },
          mode: 1,
          vetCentreLicenceNumber: "",
          registrationType: 14,
          uploadedDocument: uploadedDocument,
        };

        handleFileProcessed(bulkRequestData);
      }
    };

    reader.onerror = (error) => {
      console.error("Error reading file:", error);
      message(NotifyType.Error, "An error occurred while reading the file.");
    };

    reader.readAsArrayBuffer(selectedFile);
  };
  const generateExcelFileContent = (data: any, filename: string) => {
    if (sRegistrationType === 1) {
      const headers = [
        // { label: "Sequence Number", key: "SequenceNumber" },
        { label: "Leg Ring Number", key: "LegRingNumber" },
        { label: "Hatch Date", key: "HatchDate" },
        { label: "Source", key: "Source" },
        // Add more headers as needed
      ];
      const worksheetData = [
        headers.map((header) => header.label),
        ...data.map((item: any) => headers.map((header) => item[header.key])),
      ];
      const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "e-services");
      const excelFileContent = XLSX.write(workbook, {
        type: "binary",
        bookType: "xlsx",
      });
      const excelData = new Blob([s2ab(excelFileContent)], {
        type: "application/octet-stream",
      });
      FileSaver.saveAs(excelData, filename + ".xlsx");
    } else if (sRegistrationType === 2) {
      const headers = [
        // { label: "Sequence Number", key: "SequenceNo" },
        { label: "Tag Number", key: "TagNumber" },
        // Add more headers as needed
      ];

      const worksheetData = [
        headers.map((header) => header.label),
        ...data.map((item: any) => headers.map((header) => item[header.key])),
      ];
      const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "e-services");
      const excelFileContent = XLSX.write(workbook, {
        type: "binary",
        bookType: "xlsx",
      });
      const excelData = new Blob([s2ab(excelFileContent)], {
        type: "application/octet-stream",
      });
      FileSaver.saveAs(excelData, filename + ".xlsx");
    } else if (sRegistrationType === 3) {
      // Create a new Excel workbook
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("e-services");

      // Define dropdown options
      const VarietyofFishdropdownOptions = ["Gold", "Green", "Red"];
      let VarietyofFishlist =
        '"' + VarietyofFishdropdownOptions.join(",") + '"';

      const LengthofFishdropdownOptions = [
        "12-15 cm",
        "16-20 cm",
        "More than 20cm",
      ];
      let LengthofFishlist = '"' + LengthofFishdropdownOptions.join(",") + '"';
      // Add data to the worksheet

      if (sSourceofFish === "2") {
        worksheet.columns = [
          // { header: "Sequence Number", key: "SequenceNo" },
          { header: "Microchip Number", key: "MicrochipNumber" },
          { header: "Variety of Fish", key: "VarietyofFish" },
          { header: "Length of Fish", key: "LengthofFish" },
        ];

        for (let i = 2; i <= data.length + 1; i++) {
          worksheet.getCell(`C${i}`).dataValidation = {
            type: "list",
            formulae: [LengthofFishlist],
            showDropDown: true,
          } as any; // Cast to 'any' to avoid TypeScript error
        }
      }

      if (sSourceofFish === "1") {
        worksheet.columns = [
          // { header: "Sequence Number", key: "SequenceNo" },
          { header: "Microchip Number", key: "MicrochipNumber" },
          // { header: "Variety of Fish", key: "VarietyofFish" },
          // { header: "Brooder tag Number", key: "BrooderTagNumber" },
        ];
      }

      // Add dropdown validation for the "DropDown Number" column
      for (let i = 2; i <= data.length + 1; i++) {
        worksheet.getCell(`B${i}`).dataValidation = {
          type: "list",
          formulae: [VarietyofFishlist],
          showDropDown: true,
        } as any; // Cast to 'any' to avoid TypeScript error
      }

      // Create a new Excel file
      workbook.xlsx.writeBuffer().then((buffer) => {
        const excelData = new Blob([buffer], {
          type: "application/octet-stream",
        });

        // Save the file
        FileSaver.saveAs(excelData, filename + ".xlsx");
      });
    }
  };

  // Helper function to convert string to ArrayBuffer
  const s2ab = (s: any) => {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < s.length; i++) {
      view[i] = s.charCodeAt(i) & 0xff;
    }
    return buf;
  };

  async function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    try {
      setSubmitted(true);
      const reCaptchaResponse = recaptchaRef.current?.getValue();
      let saltuation = isSalutationSelected();
      setSalutationSelected(saltuation);

      if (!reCaptchaResponse) {
        // reCAPTCHA validation failed
        setIsCaptchaValid(false);
        return;
      }

      if (!sscientificName) setisValidScientificName(false);
      if (checkboxChecked && saltuation && validEmail) {
        var response = null;

        if (registrationMode === "passport") {
          setSubmiting(true);
          setDisableSubmit(true);
          response = await SaveSingleRegistration(singleRequestData);

          if (response.data.data) {
            setSubmiting(false);
            setDisableSubmit(false);
            var referenceNumber = response.data.message;
            let path = `/Single-Reg-Complete`;
            navigate(path, {
              state: { RegistrationType, sSourceofFish, referenceNumber },
            });
          } else {
            setSubmiting(false);
            setDisableSubmit(false);
            setIsCaptchaValid(false);
            recaptchaRef?.current?.reset();
            // API call failed
            const errorMessage = response.data.message;
            setErrorMessage(errorMessage); // Set the error message in state
          }
        } else {
          setShowUpload(true);
          if (sRegistrationType === 1) {
            const data: { LegRingNumber: string }[] = [
              {
                // SequenceNumber: 1,
                LegRingNumber: "",
              },
            ];

            let filename = "Leg Ring Numbers for Birds";

            generateExcelFileContent([data], filename);
            let path = `/application-registration`;
            navigate(path, { state: { RegistrationType, bulkRequestData } });
          } else if (sRegistrationType === 2) {
            const data: { TagNumber: string }[] = [
              {
                // SequenceNumber: 1,
                TagNumber: "",
              },
            ];
            let filename = "Tag Numbers for Crocodile";
            generateExcelFileContent([data], filename);
            let path = `/application-registration`;
            navigate(path, { state: { RegistrationType, bulkRequestData } });
          } else if (sRegistrationType === 3) {
            const data: { MicrochipNumber: string }[] = [
              {
                // SequenceNumber: 1,
                MicrochipNumber: "",
              },
            ];

            let filename = "Microchip Numbers for DragonFish";
            generateExcelFileContent([data], filename);
            let path = `/application-registration`;
            navigate(path, { state: { RegistrationType, bulkRequestData } });
          }

          //response = await DownloadBulkRegistrationTemplate(bulkRequestData);
          //if (response.data) {

          //} else {
          //// API call failed
          //const errorMessage = "An error occurred. Please try again.";
          //setErrorMessage(errorMessage); // Set the error message in state
          //}
        }
        // Handle the API response
      }
    } catch (error) {
      // Handle any errors
      setSubmiting(false);
      setDisableSubmit(false);
      setIsCaptchaValid(false);
      recaptchaRef?.current?.reset();
      // let path = `/upload-form`;
      // navigate(path);
      const errorMessage = "An error occurred. Please try again.";
      setErrorMessage(errorMessage); // Set the error message in state
      console.error(error);
    }
  }

  (function () {
    

    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    var forms = document.querySelectorAll(".needs-validation");

    // Loop over them and prevent submission
    Array.prototype.slice.call(forms).forEach(function (form) {
      form.addEventListener(
        "submit",
        function (event: any) {
          if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
          }

          form.classList.add("was-validated");
        },
        false
      );
    });
  })();
  // Include the applicantName value in your API request
  // Prepare the request payload
  const singleRequestData: ISingleRegRequest = {
    regName: regName,
    mode: mode,
    userInformation: {
      name: user.name,
      idType: user.idType,
      idNo: user.idNo,
      email: user.email,
      contactNo: user.contactNo,
      companyName: user.companyName,
      uen: user.uen,
      registeredAddress: user.registeredAddresses?.[0],
    },
    personalInformation: {
      salutation: ssalutation,
      name: sapplicantName,
      uen: sUEN,
      nric: sNRIC,
      companyName: scompanyName,
      organizationAddress: sorganizationAddress,
      mobileNo: smobileNo,
      email: semail,
      typeofPremises: sorganizationAddress2,
      blockHouseNumber: sorganizationAddress3,
      houseNumber: sorganizationAddress4,
      streetName: sorganizationAddress5,
      floorNumber: sorganizationAddress6,
      unitNumber: sorganizationAddress7,
      buildingName: sorganizationAddress8,
      postalCode: sorganizationAddress9,
      country: sorganizationAddress10,
      mobileNoCode: smobilecode,
      licenceNumber: slicenceNumber,
      premiseCode: spremiseCode,
    },
    applicationInformation: {
      fcRegistrationNo: sfcRegistrationNo,
      //typeOfBird: stypeOfBird,
      countryOrigin: scountryOrigin,
      scientificName: sscientificName?.value ?? "",
      citesAppendixNo: scitesAppendixNo,
      foreignCITESPermitNo: sforeignCITESPermitNo,
      farmCode: sbulkFarmCode,
      legRingNo: slegRingNo,
      TypeofTag: sTypeofTag,
      TagNumber: sTagNumber,
      VarietyofFish: sVarietyofFish,
      LengthofFish: sLengthofFish,
      BatchNumber: sBatchNumber,
      RegisteredQuantityinBatch: sRegisteredQuantityinBatch,
      HarvestDate: fixTimezoneOffset(sHarvestDate),
      HatchDate: fixTimezoneOffset(sHatchDate),
      ParentMicrochip: sParentMicrochip,
      Remarks: sRemarks,
      MicrochipNumber: sMicrochipNumber,
      sourceofFish: sSourceofFish,
      expiryDate: null,
      // registrationMode: "1",
    },
    registrationType: sRegistrationType,
  };

  const bulkRequestData: IBulkRegRequest = {
    regName: regName,
    mode: mode,
    userInformation: {
      name: user.name,
      idType: user.idType,
      idNo: user.idNo,
      email: user.email,
      contactNo: user.contactNo,
      companyName: user.companyName,
      uen: user.uen,
      registeredAddress: user.registeredAddresses?.[0],
    },
    personalInformation: {
      salutation: ssalutation,
      name: sapplicantName,
      uen: sUEN,
      nric: sNRIC,
      companyName: scompanyName,
      organizationAddress: sorganizationAddress,
      mobileNo: smobileNo,
      email: semail,
      typeofPremises: sorganizationAddress2,
      blockHouseNumber: sorganizationAddress3,
      houseNumber: sorganizationAddress4,
      streetName: sorganizationAddress5,
      floorNumber: sorganizationAddress6,
      unitNumber: sorganizationAddress7,
      buildingName: sorganizationAddress8,
      postalCode: sorganizationAddress9,
      country: sorganizationAddress10,
      mobileNoCode: smobilecode,
      licenceNumber: slicenceNumber,
      premiseCode: spremiseCode,
    },
    applicationInformation: {
      fcRegistrationNo: sfcRegistrationNo,
      //typeOfBird: stypeOfBird,
      countryOrigin: scountryOrigin,
      scientificName: sscientificName?.value ?? "",
      citesAppendixNo: scitesAppendixNo,
      foreignCITESPermitNo: sforeignCITESPermitNo,
      farmCode: sbulkFarmCode,
      legRingNo: slegRingNo,
      TypeofTag: sTypeofTag,
      TagNumber: sTagNumber,
      VarietyofFish: sVarietyofFish,
      LengthofFish: sLengthofFish,
      BatchNumber: sBatchNumber,
      RegisteredQuantityinBatch: sRegisteredQuantityinBatch,
      HarvestDate: sHarvestDate,
      HatchDate: sHatchDate,
      ParentMicrochip: sParentMicrochip,
      Remarks: sRemarks,
      MicrochipNumber: sMicrochipNumber,
      sourceofFish: sSourceofFish,
      expiryDate: null,
      // registrationMode: "1",
    },
    registrationType: sRegistrationType,
    uploadedDocument: "",
  };

  const handleRegistrationModeChange = (e: ChangeEvent<HTMLInputElement>) => {
    setRegistrationMode(e.target.value);
    if (e.target.value === "passport") {
      mode = 1;
      setregName("Bird Single Registration");
    } else {
      mode = 2;
      setregName("Bird Bulk Registration");
    }
  };

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    setsEmail(value);
    if (pattern.test(value)) {
      setValidEmail(true);
    } else {
      if (value === "") {
        setValidEmail(true);
      } else {
        setValidEmail(false);
      }
    }
  };

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheckboxChecked(event.target.checked);
  };

  const isSalutationSelected = () => {
    return ssalutation !== null && ssalutation !== 0;
  };

  const handleNewReg = () => {
    let path = `/application-registration`;
    navigate(path, { state: { RegistrationType, bulkRequestData } });

    window.location.reload();
  };

  return (
    <>
      {!isFromRegistrationLink && (
        <div className="row">
          <div className="col-lg-9">
            <h2>Registration</h2>
          </div>
          <div className="col-lg-3">
            <button
              className="btn btn-success d-block"
              onClick={() => handleNewReg()}
            >
              New Registration
            </button>
          </div>
        </div>
      )}
      {/* <h2 className="pb-2">Registration</h2> */}
      <span className="est-time">
        <i className="fas fa-clock"></i> Estimated time to complete: 15 mins
      </span>
      <form>
        <div className="inst-cnt mt-4 mb-2">
          <div className="mb-2 reg-mode">
            <label htmlFor="registrationMode" className="form-label mb-2">
              Select Registration Mode <span className="star">*</span>{" "}
            </label>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="registrationMode"
                value="passport"
                id="flexRadioDefault"
                checked={registrationMode === "passport"}
                onChange={handleRegistrationModeChange}
              />
              <label className="form-check-label" htmlFor="flexRadioDefault">
                Single
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="registrationMode"
                value="Malaysian"
                id="flexRadioDefault1"
                checked={registrationMode === "Malaysian"}
                onChange={handleRegistrationModeChange}
              />
              <label className="form-check-label" htmlFor="flexRadioDefault1">
                Bulk Registration
              </label>
            </div>
          </div>
        </div>
      </form>
      <form
        className="row g-3 needs-validation"
        onSubmit={handleSubmit}
        noValidate
      >
        <h2 className="pb-0">User Information</h2>
        <div className="inst-cnt mt-4 mb-2">
          <div className="row">
            <div className="col-lg-6 row">
              <div className="col-md-5">
                <label htmlFor="name" className="form-label mb-2">
                  Name :
                </label>
              </div>
              <div className="col-md-7">
                <label className="form-label mb-2 fw-bold">{user.name}</label>
              </div>
            </div>
            <div className="col-lg-6 row">
              <div className="col-md-4">
                <label htmlFor="name" className="form-label mb-2 mr-10">
                  NRIC :
                </label>
              </div>
              <div className="col-md-8">
                <label className="form-label mb-2 fw-bold">{user.idNo}</label>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 row">
              <div className="col-md-5">
                <label htmlFor="name" className="form-label mb-2">
                  Mobile Number :
                </label>
              </div>
              <div className="col-md-7">
                <label className="form-label mb-2 fw-bold">
                  {user.contactNo}
                </label>
              </div>
            </div>
            <div className="col-lg-6 row">
              <div className="col-md-4">
                <label htmlFor="name" className="form-label mb-2 mr-10">
                  Email :
                </label>
              </div>
              <div className="col-md-8">
                <label className="form-label mb-2 fw-bold">{user.email}</label>
              </div>
            </div>
          </div>
          <div className="row">
            <label htmlFor="name" className="form-label mb-2 fw-bold">
              Address
            </label>
          </div>
          <div className="row">
            <div className="col-lg-6 row">
              <div className="col-md-5">
                <label htmlFor="name" className="form-label mb-2">
                  Block/House Number :
                </label>
              </div>
              <div className="col-md-7">
                <label className="form-label mb-2 fw-bold">
                  {user.registeredAddresses?.[0]?.blockHouseNo}
                </label>
              </div>
            </div>
            <div className="col-lg-6 row">
              <div className="col-md-4">
                <label htmlFor="name" className="form-label mb-2 mr-10">
                  Floor Number :
                </label>
              </div>
              <div className="col-md-8">
                <label className="form-label mb-2 fw-bold">
                  {user.registeredAddresses?.[0]?.floorLevel}
                </label>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 row">
              <div className="col-md-5">
                <label htmlFor="name" className="form-label mb-2">
                  Street Name :
                </label>
              </div>
              <div className="col-md-7">
                <label className="form-label mb-2 fw-bold">
                  {user.registeredAddresses?.[0]?.streetName}
                </label>
              </div>
            </div>
            <div className="col-lg-6 row">
              <div className="col-md-4">
                <label htmlFor="name" className="form-label mb-2 mr-10">
                  Unit Number :
                </label>
              </div>
              <div className="col-md-8">
                <label className="form-label mb-2 fw-bold">
                  {user.registeredAddresses?.[0]?.unit}
                </label>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 row">
              <div className="col-md-5">
                <label htmlFor="name" className="form-label mb-2">
                  Building Name :
                </label>
              </div>
              <div className="col-md-7">
                <label className="form-label mb-2 fw-bold">
                  {user.registeredAddresses?.[0]?.buildingName}
                </label>
              </div>
            </div>
            <div className="col-lg-6 row">
              <div className="col-md-4">
                <label htmlFor="name" className="form-label mb-2 mr-10">
                  Postal Code :
                </label>
              </div>
              <div className="col-md-8">
                <label className="form-label mb-2 fw-bold">
                  {user.registeredAddresses?.[0]?.postalCode}
                </label>
              </div>
            </div>
          </div>
        </div>
        {isFromRegistrationLink && (
          <div className="inst-cnt mt-2">
            <div className="mb-2">
              <label htmlFor="sourceofFish" className="form-label mb-2">
                Source of Fish <span className="star">*</span>
              </label>
              <select
                className="form-select"
                aria-label="Default select example"
                id="sSourceofFish"
                value={sSourceofFish}
                disabled
                onChange={(e) => setsSourceofFish(e.target.value)}
              >
                <option value="1">Local Production</option>
              </select>
              <div className="invalid-feedback">
                Please select Source of Fish.
              </div>
            </div>
          </div>
        )}
        {registrationMode === "passport" && (
          <div
            className="passport-details hidden csp-display-block"
            id="passport"
          >
            <h2 className="pb-0">Personal Information</h2>
            <div className="inst-cnt mt-2">
              {showDragonFish && !isFromRegistrationLink && (
                <div className="mb-2">
                  {/* <input
                    className="form-check-input"
                    type="checkbox"
                    checked={sSourceofFish}
                    onChange={handleSourceofFishChange}
                    id="sSourceofFish"
                    required
                  /> */}
                  <label htmlFor="sourceofFish" className="form-label mb-2">
                    Source of Fish <span className="star">*</span>
                  </label>
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    id="sSourceofFish"
                    value={sSourceofFish}
                    onChange={(e) => setsSourceofFish(e.target.value)}
                  >
                    <option value="">Select Source of Fish</option>
                    <option value="1">Local Production</option>
                    <option value="2">Non-Local Production</option>
                  </select>
                  <div className="invalid-feedback">
                    Please select Source of Fish.
                  </div>
                </div>
              )}
              {user.role === "CorpPass" && (
                <div className="mb-2 ">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-2"
                  >
                    UEN <span className="star">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="sUEN"
                    placeholder=""
                    maxLength={12}
                    value={sUEN}
                    onChange={(event) => setsUEN(event.target.value)}
                    onBlur={handleUENBlur}
                    required
                  />
                  <div className="invalid-feedback">Please provide a UEN.</div>
                </div>
              )}
              {((sSourceofFish && showDragonFish) ||
                showBird ||
                showCrocodile) && (
                <div>
                  <div className="mb-2 ">
                    <label
                      htmlFor="exampleFormControlInput1"
                      className="form-label mb-2"
                    >
                      Company Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="scompanyName"
                      placeholder=""
                      maxLength={100}
                      value={scompanyName}
                      onChange={(event) => setsCompanyName(event.target.value)}
                    />
                  </div>
                  <div className="mb-2">
                    <label
                      htmlFor="exampleFormControlInput1"
                      className={`form-label mb-2 ${
                        !isSalutationSelected() ? "required" : ""
                      }`}
                    >
                      Salutation <span className="star">*</span>{" "}
                    </label>
                    <div
                      className={`form-check ${
                        !isSalutationSelected() ? "is-invalid" : ""
                      }`}
                    >
                      <input
                        className="form-check-input"
                        type="radio"
                        name="ssalutation"
                        value="Dr"
                        id="flexRadioDefault11"
                        checked={ssalutation === 1}
                        onChange={() => setsSalutation(1)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="flexRadioDefault11"
                      >
                        Dr
                      </label>
                    </div>
                    <div
                      className={`form-check ${
                        !isSalutationSelected() ? "is-invalid" : ""
                      }`}
                    >
                      <input
                        className="form-check-input"
                        type="radio"
                        name="ssalutation"
                        value="Mdm"
                        id="flexRadioDefault22"
                        checked={ssalutation === 2}
                        onChange={() => setsSalutation(2)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="flexRadioDefault22"
                      >
                        Mdm
                      </label>
                    </div>
                    <div
                      className={`form-check ${
                        !isSalutationSelected() ? "is-invalid" : ""
                      }`}
                    >
                      <input
                        className="form-check-input"
                        type="radio"
                        name="ssalutation"
                        value="Miss"
                        id="flexRadioDefault33"
                        checked={ssalutation === 3}
                        onChange={() => setsSalutation(3)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="flexRadioDefault33"
                      >
                        Miss
                      </label>
                    </div>
                    <div
                      className={`form-check ${
                        !isSalutationSelected() ? "is-invalid" : ""
                      }`}
                    >
                      <input
                        className="form-check-input"
                        type="radio"
                        name="ssalutation"
                        value="Mr"
                        id="flexRadioDefault55"
                        checked={ssalutation === 4}
                        onChange={() => setsSalutation(4)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="flexRadioDefault55"
                      >
                        Mr
                      </label>
                    </div>
                    <div
                      className={`form-check ${
                        !isSalutationSelected() ? "is-invalid" : ""
                      }`}
                    >
                      <input
                        className="form-check-input"
                        type="radio"
                        name="ssalutation"
                        value="Mrs"
                        id="flexRadioDefault66"
                        checked={ssalutation === 5}
                        onChange={() => setsSalutation(5)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="flexRadioDefault66"
                      >
                        Mrs
                      </label>
                    </div>
                    {submitted && !isSalutationSelected() && (
                      <div className="invalid-feedback">
                        Please select a Salutation.
                      </div>
                    )}
                  </div>
                  <div className="mb-2">
                    <label htmlFor="sapplicantName" className="form-label mb-2">
                      Name of Applicant <span className="star">*</span>{" "}
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="sapplicantName"
                      placeholder="Type Applicant Name as per NRIC / Passport"
                      value={sapplicantName}
                      maxLength={255}
                      onChange={(event) =>
                        setsApplicantName(event.target.value)
                      }
                      required
                    />
                    <div className="invalid-feedback">
                      Please provide a Applicant Name.
                    </div>
                  </div>
                  <div className="mb-2">
                    <label
                      htmlFor="exampleFormControlInput1"
                      className="form-label mb-2"
                    >
                      NRIC <span className="star">*</span>{" "}
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="sNRIC"
                      placeholder="NRIC"
                      maxLength={255}
                      value={sNRIC}
                      onChange={(event) => setsNRIC(event.target.value)}
                      required
                    />
                    <div className="invalid-feedback">
                      Please provide a Name of Applicant.
                    </div>
                  </div>
                  {showDragonFish && (
                    <div className="mb-2 ">
                      {sSourceofFish === "1" && (
                        <label
                          htmlFor="exampleFormControlInput1"
                          className="form-label mb-2"
                        >
                          Farm Licence Number
                        </label>
                      )}
                      {sSourceofFish === "2" && (
                        <label
                          htmlFor="exampleFormControlInput1"
                          className="form-label mb-2"
                        >
                          Licence Number <span className="star">*</span>
                        </label>
                      )}
                      {sSourceofFish === "1" && (
                        <input
                          type="text"
                          className="form-control"
                          id="slicenceNumber"
                          placeholder=""
                          maxLength={100}
                          value={slicenceNumber}
                          onChange={(event) =>
                            setsLicenceNumber(event.target.value)
                          }
                          onBlur={handleLicenceNumberBlurNew}
                        />
                      )}
                      {sSourceofFish === "2" && (
                        <input
                          type="text"
                          className="form-control"
                          id="slicenceNumber"
                          placeholder=""
                          maxLength={100}
                          value={slicenceNumber}
                          onChange={(event) =>
                            setsLicenceNumber(event.target.value)
                          }
                          onBlur={handleLicenceNumberBlurNew}
                          required
                        />
                      )}
                      <div className="invalid-feedback">
                        Please provide a Licence Number.
                      </div>

                      {!licenceNumberNoShowError && (
                        <div className="error-message">
                          Licence Number does not exists in our records. Please
                          review your information and try again.
                        </div>
                      )}
                      {!uenNoShowError && (
                        <div className="error-message">
                          UEN does not match Licence Number in our records.
                          Please review your information and try again.
                        </div>
                      )}
                    </div>
                  )}
                  {showDragonFish && (
                    <div className="mb-2 ">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-2"
                      >
                        Premise Code <span className="star">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="spremiseCode"
                        placeholder=""
                        maxLength={100}
                        value={spremiseCode}
                        onChange={(event) =>
                          setsPremiseCode(event.target.value)
                        }
                        onBlur={handlePremiseCodeBlur}
                        required
                      />
                      <div className="invalid-feedback">
                        Please provide premise code.
                      </div>
                      {!premiseCodeNoShowError && (
                        <div className="error-message  mb-3">
                          Premise Code does not exists
                        </div>
                      )}
                      {!batchNumberNoShowError && (
                        <div className="error-message">
                          Batch numbers are not available for the premise code.
                          Please review your information and try again.
                        </div>
                      )}
                      {!premiseCodeHarvestDetailNoShowError && (
                        <div className="error-message">
                          Harvest details are not available for the premise
                          code. Please review your information and try again.
                        </div>
                      )}
                    </div>
                  )}
                  <div className="mb-2 ">
                    <label
                      htmlFor="exampleFormControlInput1"
                      className="form-label mb-2"
                    >
                      Address
                    </label>
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="mb-3 position-relative">
                          <select
                            className="form-select"
                            aria-label="Default select example"
                            id="sorganizationAddress"
                            //placeholder="Address Type"
                            value={sorganizationAddress}
                            onChange={(e) =>
                              setsOrganizationAddress(e.target.value)
                            }
                            required
                          >
                            {/* <option value="">Address Type</option> */}
                            <option value="1">Local</option>
                            {/* <option value="2">Foreign</option> */}
                          </select>
                          <span                            
                            className="star csp-abs-ml-100-mt--30"
                          >
                            *
                          </span>
                          <div className="invalid-feedback mb-3">
                            Please provide an Address.
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="mb-3">
                          <select
                            className="form-select"
                            aria-label="Default select example"
                            id="sorganizationAddress2"
                            value={sorganizationAddress2}
                            onChange={(e) =>
                              setsOrganizationAddress2(e.target.value)
                            }
                          >
                            <option value="">Select Type of Premises</option>
                            <option value="1">Cold Room[CR]</option>
                            <option value="2">
                              Factory and Processing Plant[FPP]
                            </option>
                            <option value="3">Farm[FM]</option>
                            <option value="4">Food Factory[FF]</option>
                            <option value="5">Office[OF]</option>
                            <option value="6">Residential[RE]</option>
                            <option value="7">Retail Outlet[RO]</option>
                            <option value="8">Show Room[SR]</option>
                            <option value="9">Warehouse[WH]</option>
                            <option value="10">FeedMill[FM]</option>
                          </select>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="mb-3 position-relative">
                          <input
                            type="text"
                            className="form-control"
                            id="sorganizationAddress3"
                            placeholder="Block/House Number"
                            maxLength={15}
                            value={sorganizationAddress3}
                            onChange={blockNoHandler}
                            required
                          />
                          <span                           
                            className="star csp-abs-ml-100-mt--30"
                          >
                            *
                          </span>

                          <div className="invalid-feedback mb-3">
                            Please provide a Block/House Num.
                          </div>
                          {!blockNoShowError && (
                            <div className="error-message">
                              Please enter charaters only. eg. "64FB"
                            </div>
                          )}
                        </div>
                      </div>
                      {/* <div className="col-lg-6">
                    <div className="mb-3">
                      <input
                        type="text"
                        className="form-control"
                        id="sorganizationAddress4"
                        placeholder="House Number"
                        maxLength={10}
                        value={sorganizationAddress4}
                        onChange={(event) =>
                          setsOrganizationAddress4(event.target.value)
                        }
                      />
                    </div>
                  </div> */}
                      <div className="col-lg-6">
                        <div className="mb-3">
                          <input
                            type="text"
                            className="form-control"
                            id="sorganizationAddress6"
                            placeholder="Floor Number"
                            pattern="^[a-zA-Z0-9\s]+$"
                            value={sorganizationAddress6}
                            onChange={floorNoHandler}
                            maxLength={3}
                          />
                          {!floorNoShowError && (
                            <div className="error-message  mb-3">
                              Please enter numbers eg. "123"
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="mb-3 position-relative">
                          <input
                            type="text"
                            className="form-control"
                            id="sorganizationAddress5"
                            placeholder="Street Name"
                            maxLength={64}
                            value={sorganizationAddress5}
                            onChange={(event) =>
                              setsOrganizationAddress5(event.target.value)
                            }
                            required
                          />
                          <span
                            className="star csp-abs-ml-100-mt--30"
                          >
                            *
                          </span>

                          <div className="invalid-feedback mb-3">
                            Please provide a Street Name.
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="mb-3">
                          <input
                            type="text"
                            className="form-control"
                            id="sorganizationAddress7"
                            placeholder="Unit Number"
                            pattern="^[a-zA-Z0-9\s]+$"
                            value={sorganizationAddress7}
                            onChange={unitNoHandler}
                            maxLength={4}
                          />
                          {!unitNoShowError && (
                            <div className="error-message  mb-3">
                              Please enter numbers eg. "1234"
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="mb-3 position-relative">
                          <input
                            type="text"
                            className="form-control"
                            id="sorganizationAddress9"
                            placeholder="Postal Code"
                            maxLength={8}
                            pattern="[0-9]+"
                            value={sorganizationAddress9}
                            onChange={postalCodeHandler}
                            required
                          />
                          <span
                            className="star csp-abs-ml-100-mt--30"
                          >
                            *
                          </span>

                          <div className="invalid-feedback mb-3">
                            Please provide a Postal Code.
                          </div>
                          {!postalCodeShowError && (
                            <div className="error-message">
                              Please enter numbers only. eg. "123456"
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="mb-3">
                          <input
                            type="text"
                            className="form-control"
                            id="sorganizationAddress8"
                            placeholder="Building Name"
                            maxLength={64}
                            value={sorganizationAddress8}
                            onChange={(event) =>
                              setsOrganizationAddress8(event.target.value)
                            }
                          />
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="mb-3 position-relative">
                          <select
                            className="form-select"
                            aria-label="Default select example"
                            id="sorganizationAddress10"
                            value={sorganizationAddress10}
                            onChange={handleCountryChange}
                            // value={sorganizationAddress10}
                            // onChange={(e) =>
                            //   setsOrganizationAddress10(e.target.value)
                            // }
                            required
                          >
                            {/* {countries.map((option) => {
                          if (
                            option.value ===
                            "561c1d50-093f-ed11-bba3-000d3a081401"
                          ) {
                            return (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                            );
                          }
                          return null; // If the condition is not met, return null to skip this option
                        })} */}
                            {countries.map((option) => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                            ))}
                          </select>
                          <span
                            className="star csp-abs-ml-100-mt--30"
                          >
                            *
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mb-2">
                    <label
                      htmlFor="exampleFormControlInput1"
                      className="form-label mb-2"
                    >
                      Mobile Number <span className="star">*</span>
                    </label>

                    <div className="input-grp mb-3">
                      <select
                        className="form-select"
                        aria-label="Default select example"
                        id="smobilecode"
                        value={smobilecode}
                        onChange={(e) => setsMobileCode(e.target.value)}
                        required
                      >
                        {countryMobileCodes.map((code: any) => (
                          <option key={code} value={code}>
                            {code}
                          </option>
                        ))}
                      </select>
                      <input
                        type="text"
                        aria-describedby="emailHelp"
                        className="form-control"
                        id="smobileNo"
                        placeholder=""
                        pattern="[0-9]+"
                        value={smobileNo}
                        onChange={mobileNoHandler}
                        maxLength={20}
                        required
                      />
                      <div className="invalid-feedback mb-3">
                        Please provide a mobile.
                      </div>
                      {!validMobileNo && (
                        <p className="error-message">
                          Invalid mobile no. eg. +6582365355
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="mb-2">
                    <label
                      htmlFor="exampleFormControlInput1"
                      className="form-label mb-2"
                    >
                      Email<span className="star">*</span>
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      id="semail"
                      value={semail}
                      maxLength={255}
                      onChange={handleEmailChange}
                      placeholder="Enter email"
                      required
                    />
                    <div className="invalid-feedback">
                      Please provide a email.
                    </div>
                    {!validEmail && (
                      <p className="error-message">
                        Invalid email format. eg. abc@de.lk
                      </p>
                    )}
                  </div>
                </div>
              )}
            </div>
            {((sSourceofFish && showDragonFish) ||
              showBird ||
              showCrocodile) && (
              <div>
                <h2 className="pt-2 pb-0">Application Information</h2>

                {showBird && (
                  <div className="inst-cnt mt-2">
                    <div className="mb-2">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-2"
                      >
                        Farm CITES Registration Number{" "}
                        {/* <span className="star">*</span>{" "} */}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="sfcRegistrationNo"
                        placeholder=""
                        maxLength={10}
                        value={sfcRegistrationNo}
                        onChange={(event) =>
                          setsFCRegistrationNo(event.target.value)
                        }
                        required // Make the field mandatory
                      />
                      {/* <select
                        className="form-select"
                        aria-label="Default select example"
                        id="sfcRegistrationNo"
                        value={sfcRegistrationNo}
                        onChange={(event) =>
                          setsFCRegistrationNo(event.target.value)
                        }
                        required
                      >
                        <option value=""></option>
                        {fcRegNos.map((option) => (
                          <option key={option.id} value={option.id}>
                            {option.name}
                          </option>
                        ))}
                      </select>
                      <div className="invalid-feedback">
                        Please provide a Farm CITES Registration Number.
                      </div> */}
                    </div>
                    <div className="mb-2">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-2"
                      >
                        Country of Origin <span className="star">*</span>{" "}
                      </label>
                      <select
                        className="form-select"
                        aria-label="Default select example"
                        id="scountryOfOrigin"
                        value={scountryOrigin}
                        onChange={handleCountryOfOriginChange}
                        // value={scountryOrigin}
                        // onChange={(e) => setsCountryOfOrigin(e.target.value)}
                        required
                      >
                        {countries.map((option) => (
                          <option
                            key={option.value}
                            value={option.value}
                            selected={option.label === "Singapore"}
                          >
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="mb-2 ">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-2"
                      >
                        CITES Appendix Number <span className="star">*</span>
                      </label>
                      <select
                        className="form-select"
                        id="scitesAppendixNo"
                        value={scitesAppendixNo}
                        onChange={handleCitesAppendixChange}
                        required
                      >
                        <option value=""></option>
                        <option value={1}>I</option>
                        <option value={2}>II</option>
                        <option value={3}>III</option>
                      </select>
                      <div className="invalid-feedback">
                        Please provide CITES Appendix Number.
                      </div>
                    </div>
                    <div className="mb-2">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-2"
                      >
                        Scientific Name / Common Name{" "}
                        <span className="star">*</span>{" "}
                      </label>
                      {/* <select
                        className="form-select"
                        aria-label="Default select example"
                        id="sscientificName"
                        value={sscientificName}
                        onChange={(e) => setsScientificName(e.target.value)}
                        required
                      >
                        <option value=""></option>
                        <option value="1">
                          Accipiter brevipes / Levant Sparrowhawk
                        </option>
                        <option value="2">
                          Butastur teesa / White-eyed Buzzard
                        </option>
                        <option value="3">
                          Campylopterus falcatus / Lazuline Sabrewing
                        </option>
                        <option value="4">
                          Eos reticulata / Blue-streaked Lory
                        </option>
                        <option value="5">
                          Forpus cyanopygius / Mexican Parrotlet
                        </option>
                      </select> */}
                      <div className="rs-container">
                      <Select<Option,false>
                       classNamePrefix="rs"
                        id="sscientificName"
                        options={scientificNames}                        
                        value={scientificNames.find((o: any) => o.value === sscientificNameString) ?? null}
                        onChange={handleSelect}
                        required
                        isDisabled={disableScientificName}
                        placeholder="Select Scientific Name"                        
                        isSearchable={true}
                        isClearable={false}                       
                        maxMenuHeight={260}
                        menuPlacement="auto"
                        filterOption={(option, inputValue) =>
                          option.label.toLowerCase().includes(inputValue.toLowerCase())
                        }
                      />
                      <div className="invalid-feedback">
                        Please provide a Scientific Name.
                      </div>
                      </div>
                    </div>
                    <div className="mb-2 ">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-2"
                      >
                        Foreign CITES Permit Number{" "}
                        {scountryOrigin !== defaultCountryId && (
                          <span className="star">*</span>
                        )}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="sforeignCITESPermitNo"
                        placeholder=""
                        value={sforeignCITESPermitNo}
                        onChange={(event) =>
                          setsForeignCITESPermitNo(event.target.value)
                        }
                        required={scountryOrigin !== defaultCountryId}
                      />
                      <div className="invalid-feedback">
                        Please provide a Foreign CITES Permit Number.
                      </div>
                    </div>
                    <div className="mb-2">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-2"
                      >
                        Leg Ring Number <span className="star">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="slegRingNo"
                        placeholder=""
                        maxLength={16}
                        value={slegRingNo}
                        onChange={(event) => setsLegRingNo(event.target.value)}
                        required
                      />
                      <div className="invalid-feedback">
                        Please provide a Leg Ring Number.
                      </div>
                    </div>
                    <div className="mb-2">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-2"
                      >
                        Hatch date{" "}
                        {scountryOrigin === defaultCountryId && (
                          <span className="star">*</span>
                        )}
                      </label>
                      {/* <input
                        type="date"
                        className="form-control"
                        id="hatchDate"
                        value={hatchDate}
                        onChange={handleDateChange}
                        max={maxdate}
                        required={scountryOrigin === defaultCountryId}
                      /> */}
                      <DatePicker
                        id="sHatchDate"
                        selected={sHatchDate}
                        onChange={(date: Date | null) => setHatchDate(date)}
                        className="form-control"
                        wrapperClassName="w-100"
                        maxDate={new Date()}
                        showIcon
                        placeholderText="dd/mm/yyyy"
                        dateFormat="dd/MM/yyyy"
                        filterDate={(date) =>
                          !isWeekend(date) && !isHoliday(date)
                        }
                        required={scountryOrigin === defaultCountryId}
                      />
                      <div className="invalid-feedback">
                        Please provide Hatch Date.
                      </div>
                      {!isValidDate && (
                        <p className="error-message">
                          Microchip Date cannot be later than today's date.
                        </p>
                      )}
                    </div>
                  </div>
                )}
                {showCrocodile && (
                  <div className="inst-cnt mt-2">
                    <div className="mb-2">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-2"
                      >
                        Type of Tag <span className="star">*</span>{" "}
                      </label>
                      <select
                        className="form-select"
                        id="sTypeofTag"
                        value={sTypeofTag}
                        onChange={(e) => setsTypeofTag(Number(e.target.value))}
                        required
                      >
                        <option value=""></option>
                        <option value={1}>Original</option>
                        <option value={2}>Re-Tag</option>
                      </select>
                      <div className="invalid-feedback">
                        Please provide a Type of Tag.
                      </div>
                    </div>
                    <div className="mb-2">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-2"
                      >
                        Country of Origin <span className="star">*</span>{" "}
                      </label>
                      <select
                        className="form-select"
                        aria-label="Default select example"
                        id="scountryOfOrigin"
                        value={scountryOrigin}
                        onChange={handleCountryOfOriginChange}
                        required
                      >
                        {countries.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="mb-2 ">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-2"
                      >
                        CITES Appendix Number <span className="star">*</span>
                      </label>
                      <select
                        className="form-select"
                        id="scitesAppendixNo"
                        value={scitesAppendixNo}
                        onChange={handleCitesAppendixChange}
                        required
                      >
                        <option value=""></option>
                        <option value={1}>I</option>
                        <option value={2}>II</option>
                        <option value={3}>III</option>
                      </select>
                      <div className="invalid-feedback">
                        Please provide CITES Appendix Number.
                      </div>
                    </div>
                    <div className="mb-2">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-2"
                      >
                        Scientific Name / Common Name{" "}
                        <span className="star">*</span>{" "}
                      </label>
                      {/* <select
                        className="form-select"
                        aria-label="Default select example"
                        id="sscientificName"
                        value={sscientificName}
                        onChange={(e) => setsScientificName(e.target.value)}
                        required
                      >
                        <option value=""></option>
                        <option value="1">
                          Caiman latirostris / Brazilian caiman
                        </option>
                        <option value="2">
                          Crocodylus rhombifer / Cuban Crocodile
                        </option>
                        <option value="3">
                          Osteolaemus tetraspis / West African Dwarf Crocodile
                        </option>
                      </select> */}
                      <div className="rs-container">
                      <Select<Option,false>
                       classNamePrefix="rs"
                        id="sscientificName"
                        options={scientificNames}                        
                        value={scientificNames.find((o: any) => o.value === sscientificNameString) ?? null}
                        onChange={handleSelect}
                        required
                        isDisabled={disableScientificName}
                        placeholder="Select Scientific Name"                        
                        isSearchable={true}
                        isClearable={false}                       
                        maxMenuHeight={260}
                        menuPlacement="auto"
                        filterOption={(option, inputValue) =>
                          option.label.toLowerCase().includes(inputValue.toLowerCase())
                        }
                      />
                      <div className="invalid-feedback">
                        Please provide a Scientific Name.
                      </div>
                      </div>
                    </div>
                    <div className="mb-2 ">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-2"
                      >
                        Foreign CITES Permit Number{" "}
                        {scountryOrigin !== defaultCountryId && (
                          <span className="star">*</span>
                        )}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="sforeignCITESPermitNo"
                        placeholder=""
                        value={sforeignCITESPermitNo}
                        onChange={(event) =>
                          setsForeignCITESPermitNo(event.target.value)
                        }
                        required={scountryOrigin !== defaultCountryId}
                      />
                      <div className="invalid-feedback">
                        Please provide a Foreign CITES Permit Number.
                      </div>
                    </div>
                    <div className="mb-2">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-2"
                      >
                        Tag Number <span className="star">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="sTagNumber"
                        maxLength={16}
                        placeholder=""
                        value={sTagNumber}
                        onChange={(event) => setsTagNumber(event.target.value)}
                        required
                      />
                      <div className="invalid-feedback">
                        Please provide a Tag Number.
                      </div>
                    </div>
                  </div>
                )}
                {showDragonFish && (
                  <div className="inst-cnt mt-2">
                    <div className="mb-2">
                      {sSourceofFish === "1" && (
                        <label
                          htmlFor="exampleFormControlInput1"
                          className="form-label mb-2"
                        >
                          Farm CITES Registration Number{" "}
                        </label>
                      )}
                      {sSourceofFish === "2" && (
                        <label
                          htmlFor="exampleFormControlInput1"
                          className="form-label mb-2"
                        >
                          Farm CITES Registration Number{" "}
                          <span className="star">*</span>{" "}
                        </label>
                      )}
                      {/* <input
                        type="text"
                        className="form-control"
                        id="sfcRegistrationNo"
                        placeholder=""
                        maxLength={10}
                        value={sfcRegistrationNo}
                        onChange={(event) =>
                          setsFCRegistrationNo(event.target.value)
                        }
                      /> */}
                      <select
                        className="form-select"
                        aria-label="Default select example"
                        id="sfcRegistrationNo"
                        value={sfcRegistrationNo}
                        onChange={(event) =>
                          setsFCRegistrationNo(event.target.value)
                        }
                      >
                        <option value=""></option>
                        {fcRegNos.map((option) => (
                          <option key={option.id} value={option.id}>
                            {option.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    {sSourceofFish === "2" && (
                      <div className="mb-2">
                        <label
                          htmlFor="exampleFormControlInput1"
                          className="form-label mb-2"
                        >
                          Variety of Fish <span className="star">*</span>{" "}
                        </label>
                        <select
                          className="form-select"
                          id="sVarietyofFish"
                          value={sVarietyofFish}
                          onChange={(e) =>
                            setsVarietyofFish(Number(e.target.value))
                          }
                          required
                        >
                          <option value=""></option>
                          <option value={1}>Red</option>
                          <option value={2}>Gold</option>
                          <option value={3}>Green</option>
                        </select>
                        <div className="invalid-feedback">
                          Please provide a Variety of Fish.
                        </div>
                      </div>
                    )}
                    <div className="mb-2">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-2"
                      >
                        Country of Origin <span className="star">*</span>{" "}
                      </label>
                      <select
                        className="form-select"
                        aria-label="Default select example"
                        id="scountryOfOrigin"
                        value={scountryOrigin}
                        onChange={handleCountryOfOriginChange}
                        required
                      >
                        {sSourceofFish === "1" &&
                          countries.map(
                            (option) =>
                              option.label === "Singapore" && (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              )
                          )}
                        {sSourceofFish === "2" &&
                          countries.map(
                            (option) =>
                              option.label !== "Singapore" && (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              )
                          )}
                      </select>
                    </div>
                    <div className="mb-2">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-2"
                      >
                        Scientific Name / Common Name{" "}
                        <span className="star">*</span>{" "}
                      </label>
                      {/* <select
                        className="form-select"
                        aria-label="Default select example"
                        id="sscientificName"
                        value={sscientificNameString}
                        onChange={(e) =>
                          setsScientificNameString(e.target.value)
                        }
                        required
                      >
                        <option value="1">
                          Scleropages formosus / Asian Arowana
                        </option>
                      </select> */}
                      <div className="rs-container">
                      <Select<Option,false>
                       classNamePrefix="rs"
                        id="sscientificName"
                        options={scientificNames}                        
                        value={scientificNames.find((o: any) => o.value === sscientificNameString) ?? null}
                        onChange={handleSelect}
                        required
                        isDisabled={disableScientificName}
                        placeholder="Select Scientific Name"                        
                        isSearchable={true}
                        isClearable={false}                       
                        maxMenuHeight={260}
                        menuPlacement="auto"
                        filterOption={(option, inputValue) =>
                          option.label.toLowerCase().includes(inputValue.toLowerCase())
                        }
                      />
                      <div className="invalid-feedback">
                        Please provide a Scientific Name.
                      </div>
                      </div>
                    </div>
                    <div className="mb-2">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-2"
                      >
                        Length of Fish <span className="star">*</span>{" "}
                      </label>
                      <select
                        className="form-select"
                        aria-label="Default select example"
                        id="sLengthofFish"
                        value={sLengthofFish}
                        onChange={(e) =>
                          setsLengthofFish(Number(e.target.value))
                        }
                        required
                      >
                        <option value=""></option>
                        <option value={1}>12-15cm</option>
                        <option value={2}>16-20cm</option>
                        <option value={3}>More than 20cm</option>
                      </select>
                      <div className="invalid-feedback">
                        Please provide a Length of Fish.
                      </div>
                    </div>
                    {sSourceofFish === "2" && (
                      <div>
                        <div className="mb-2 ">
                          <label
                            htmlFor="exampleFormControlInput1"
                            className="form-label mb-2"
                          >
                            CITES Appendix Number{" "}
                            <span className="star">*</span>
                          </label>
                          <select
                            className="form-select"
                            id="scitesAppendixNo"
                            value={scitesAppendixNo}
                            onChange={(e) =>
                              setsCitesAppendixNo(Number(e.target.value))
                            }
                            required
                          >
                            <option value={1}>I</option>
                          </select>
                        </div>

                        <div className="mb-2 ">
                          <label
                            htmlFor="exampleFormControlInput1"
                            className="form-label mb-2"
                          >
                            Foreign CITES Permit Number{" "}
                            {scountryOrigin !== defaultCountryId && (
                              <span className="star">*</span>
                            )}
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="sforeignCITESPermitNo"
                            placeholder=""
                            value={sforeignCITESPermitNo}
                            onChange={(event) =>
                              setsForeignCITESPermitNo(event.target.value)
                            }
                            required={scountryOrigin !== defaultCountryId}
                          />
                          <div className="invalid-feedback">
                            Please provide a Foreign CITES Permit Number.
                          </div>
                        </div>
                      </div>
                    )}
                    {sSourceofFish === "1" && (
                      <div>
                        <div className="mb-2 ">
                          <label
                            htmlFor="exampleFormControlInput1"
                            className="form-label mb-2"
                          >
                            Batch Number <span className="star">*</span>
                          </label>
                          <select
                            className="form-select"
                            aria-label="Default select example"
                            id="sBatchNumber"
                            value={sBatchNumber}
                            onChange={handleBatchNumberChange}
                            required
                          >
                            <option value="">-- Select Batch Number --</option>
                            {batchNumbers.map((option) => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                            ))}
                          </select>
                          <div className="invalid-feedback">
                            Please select a Batch Number.
                          </div>
                        </div>
                        <div className="mb-2 ">
                          <label
                            htmlFor="exampleFormControlInput1"
                            className="form-label mb-2"
                          >
                            Remaining Quantity of Fish in Batch{" "}
                            <span className="star">*</span>
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            id="sRegisteredQuantityinBatch"
                            maxLength={10}
                            placeholder=""
                            value={sRegisteredQuantityinBatch}
                            onChange={(event) =>
                              setsRegisteredQuantityinBatch(
                                Number(event.target.value)
                              )
                            }
                            min={1}
                            required
                            disabled
                          />
                          <div className="invalid-feedback">
                            Please provide a Remaining Quantity of Fish in
                            Batch.
                          </div>
                        </div>
                        <div className="mb-2 ">
                          <label
                            htmlFor="exampleFormControlInput1"
                            className="form-label mb-2"
                          >
                            Harvest Date <span className="star">*</span>
                          </label>
                          <DatePicker
                            id="sHarvestDate"
                            selected={sHarvestDate}
                            onChange={(date: Date | null) => setsHarvestDate(date)}
                            className="form-control"
                            wrapperClassName="w-100"
                            minDate={minDate}
                            showIcon
                            placeholderText="dd/mm/yyyy"
                            dateFormat="dd/MM/yyyy"
                            filterDate={(date) =>
                              !isWeekend(date) && !isHoliday(date)
                            }
                            required
                            disabled
                          />
                          <div className="invalid-feedback">
                            Please provide a Harvest Date.
                          </div>
                        </div>
                        {sSourceofFish === "1" && (
                          <div className="mb-2">
                            <label
                              htmlFor="exampleFormControlInput1"
                              className="form-label mb-2"
                            >
                              Variety of Fish<span className="star">*</span>
                            </label>
                            <select
                              className="form-select"
                              aria-label="Default select example"
                              id="variety"
                              value={sVarietyofFish}
                              onChange={(e) =>
                                setsVarietyofFish(Number(e.target.value))
                              }
                              disabled
                              required
                            >
                              <option value="" hidden>
                                Variety
                              </option>
                              <option value="1">Red [RED]</option>
                              <option value="2">Gold [GOL]</option>
                              <option value="3">Green [GRE]</option>
                            </select>
                            <div className="invalid-feedback">
                              Please select a Variety.
                            </div>
                          </div>
                        )}
                        <div className="mb-2 ">
                          <label
                            htmlFor="exampleFormControlInput1"
                            className="form-label mb-2"
                          >
                            Parent Microchip <span className="star">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="sParentMicrochip"
                            placeholder=""
                            maxLength={16}
                            value={sParentMicrochip}
                            onChange={(event) =>
                              setsParentMicrochip(event.target.value)
                            }
                            required
                            disabled
                          />
                          <div className="invalid-feedback">
                            Please provide a Parent Microchip.
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="mb-2 ">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-2"
                      >
                        Remarks{" "}
                        {!showDragonFish && <span className="star">*</span>}
                      </label>
                      {/* <input
                        type="text"
                        className="form-control"
                        id="sRemarks"
                        placeholder=""
                        maxLength={60}
                        value={sRemarks}
                        onChange={(event) => setsRemarks(event.target.value)}
                        required={!showDragonFish}
                      /> */}
                      <textarea
                        rows={3}
                        className="form-control"
                        id="sRemarks"
                        placeholder=""
                        maxLength={1000}
                        value={sRemarks}
                        onChange={(event) => setsRemarks(event.target.value)}
                        required={!showDragonFish}
                      ></textarea>
                      <div className="invalid-feedback">
                        Please provide a Remarks.
                      </div>
                    </div>
                    <div className="mb-2 ">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-2"
                      >
                        Microchip Number <span className="star">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="sMicrochipNumber"
                        placeholder=""
                        maxLength={16}
                        value={sMicrochipNumber}
                        onChange={(event) =>
                          setsMicrochipNumber(event.target.value)
                        }
                        required
                      />
                      <div className="invalid-feedback">
                        Please provide a Microchip Number.
                      </div>
                    </div>
                  </div>
                )}
                <h2>Declaration</h2>
                <div className="inst-cnt mb-2">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={checkboxChecked}
                      onChange={handleCheckboxChange}
                      id="flexCheckDefault"
                      required
                    />
                    <label className="" htmlFor="flexCheckDefault">
                      I / We, the exporter, confirm that the animal / products
                      are marked with the following seamless numbered leg rings,
                      tags, or scannable microchips.
                    </label>
                    <div className="invalid-feedback">
                      Please confirm the declaration checkbox
                    </div>
                    {submitted && !checkboxChecked && (
                      <p className="error-message">
                        Please confirm the declaration checkbox
                      </p>
                    )}
                  </div>
                </div>
                <div className="mb-3">
                  <ReCAPTCHA
                    ref={recaptchaRef}
                    sitekey={site_Key}
                    onChange={() => setIsCaptchaValid(true)}
                    onExpired={() => setIsCaptchaValid(false)}
                  />
                  {submitted && !isCaptchaValid && (
                    <div className="error-message">
                      Please complete the reCAPTCHA verification.
                    </div>
                  )}
                </div>

                <button
                  type="submit"
                  className="btn btn-success d-block mt-4"
                  disabled={disableSubmit}
                >
                  Submit
                </button>

                {/* {submitted && !salutationSelected && (
              <p className="error-message">Please select salutation</p>
            )} */}

                {errorMessage && (
                  <p className="error-message">{errorMessage}</p>
                )}
                {isSubmiting && <Loader />}
              </div>
            )}
          </div>
        )}
        {registrationMode === "Malaysian" && (
          <div
            className="malasian-details hidden csp-display-block"
            id="Malaysian"
          >
            {!isFromRegistrationLink && (
              <>
                <h2 className="pb-0">Personal Information</h2>
                <div className="inst-cnt mt-2">
                  {showDragonFish && (
                    <div className="mb-2">
                      {/* <input
                    className="form-check-input"
                    type="checkbox"
                    checked={sSourceofFish}
                    onChange={handleSourceofFishChange}
                    id="sSourceofFish"
                    required
                  /> */}
                      <label htmlFor="sourceofFish" className="form-label mb-2">
                        Source of Fish <span className="star">*</span>
                      </label>
                      <select
                        className="form-select"
                        aria-label="Default select example"
                        id="sSourceofFish"
                        value={sSourceofFish}
                        onChange={(e) => setsSourceofFish(e.target.value)}
                      >
                        <option value="">Select Source of Fish</option>
                        <option value="1">Local Production</option>
                        <option value="2">Non-Local Production</option>
                      </select>
                      <div className="invalid-feedback">
                        Please select Source of Fish.
                      </div>
                    </div>
                  )}
                  {user.role === "CorpPass" && (
                    <div className="mb-2 ">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-2"
                      >
                        UEN <span className="star">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="sUEN"
                        placeholder=""
                        maxLength={12}
                        value={sUEN}
                        onChange={(event) => setsUEN(event.target.value)}
                        onBlur={handleUENBlur}
                        required
                      />
                      <div className="invalid-feedback">
                        Please provide a UEN.
                      </div>
                    </div>
                  )}
                  <div className="mb-2 ">
                    <label
                      htmlFor="exampleFormControlInput1"
                      className="form-label mb-2"
                    >
                      Company Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="scompanyName"
                      maxLength={100}
                      placeholder=""
                      value={scompanyName}
                      onChange={(event) => setsCompanyName(event.target.value)}
                    />
                  </div>
                  {((sSourceofFish && showDragonFish) ||
                    showBird ||
                    showCrocodile) && (
                    <div>
                      <div className="mb-2">
                        <label
                          htmlFor="exampleFormControlInput1"
                          className={`form-label mb-2 ${
                            !isSalutationSelected() ? "required" : ""
                          }`}
                        >
                          Salutation <span className="star">*</span>{" "}
                        </label>
                        <div
                          className={`form-check ${
                            !isSalutationSelected() ? "is-invalid" : ""
                          }`}
                        >
                          <input
                            className="form-check-input"
                            type="radio"
                            name="ssalutation"
                            value="Dr"
                            id="flexRadioDefault11"
                            checked={ssalutation === 1}
                            onChange={() => setsSalutation(1)}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="flexRadioDefault11"
                          >
                            Dr
                          </label>
                        </div>
                        <div
                          className={`form-check ${
                            !isSalutationSelected() ? "is-invalid" : ""
                          }`}
                        >
                          <input
                            className="form-check-input"
                            type="radio"
                            name="ssalutation"
                            value="Mdm"
                            id="flexRadioDefault22"
                            checked={ssalutation === 2}
                            onChange={() => setsSalutation(2)}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="flexRadioDefault22"
                          >
                            Mdm
                          </label>
                        </div>
                        <div
                          className={`form-check ${
                            !isSalutationSelected() ? "is-invalid" : ""
                          }`}
                        >
                          <input
                            className="form-check-input"
                            type="radio"
                            name="ssalutation"
                            value="Miss"
                            id="flexRadioDefault33"
                            checked={ssalutation === 3}
                            onChange={() => setsSalutation(3)}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="flexRadioDefault33"
                          >
                            Miss
                          </label>
                        </div>
                        <div
                          className={`form-check ${
                            !isSalutationSelected() ? "is-invalid" : ""
                          }`}
                        >
                          <input
                            className="form-check-input"
                            type="radio"
                            name="ssalutation"
                            value="Mr"
                            id="flexRadioDefault55"
                            checked={ssalutation === 4}
                            onChange={() => setsSalutation(4)}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="flexRadioDefault55"
                          >
                            Mr
                          </label>
                        </div>
                        <div
                          className={`form-check ${
                            !isSalutationSelected() ? "is-invalid" : ""
                          }`}
                        >
                          <input
                            className="form-check-input"
                            type="radio"
                            name="ssalutation"
                            value="Mrs"
                            id="flexRadioDefault66"
                            checked={ssalutation === 5}
                            onChange={() => setsSalutation(5)}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="flexRadioDefault66"
                          >
                            Mrs
                          </label>
                        </div>
                        {submitted && !isSalutationSelected() && (
                          <div className="invalid-feedback">
                            Please select a Salutation.
                          </div>
                        )}
                      </div>
                      <div className="mb-2">
                        <label
                          htmlFor="exampleFormControlInput1"
                          className="form-label mb-2"
                        >
                          Name of Applicant <span className="star">*</span>{" "}
                        </label>

                        <input
                          type="text"
                          className="form-control"
                          id="sapplicantName"
                          placeholder="Type Applicant Name as per NRIC / Passport"
                          maxLength={255}
                          value={sapplicantName}
                          onChange={(event) =>
                            setsApplicantName(event.target.value)
                          }
                          required
                        />
                        <div className="invalid-feedback">
                          Please provide a Name of Applicant.
                        </div>
                      </div>
                      <div className="mb-2">
                        <label
                          htmlFor="exampleFormControlInput1"
                          className="form-label mb-2"
                        >
                          NRIC <span className="star">*</span>{" "}
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="sNRIC"
                          placeholder="NRIC"
                          maxLength={255}
                          value={sNRIC}
                          onChange={(event) => setsNRIC(event.target.value)}
                          required
                        />
                        <div className="invalid-feedback">
                          Please provide a Name of Applicant.
                        </div>
                      </div>
                      {showDragonFish && (
                        <div className="mb-2 ">
                          {sSourceofFish === "1" && (
                            <label
                              htmlFor="exampleFormControlInput1"
                              className="form-label mb-2"
                            >
                              Farm Licence Number
                            </label>
                          )}
                          {sSourceofFish === "2" && (
                            <label
                              htmlFor="exampleFormControlInput1"
                              className="form-label mb-2"
                            >
                              Licence Number <span className="star">*</span>
                            </label>
                          )}
                          {sSourceofFish === "1" && (
                            <input
                              type="text"
                              className="form-control"
                              id="slicenceNumber"
                              placeholder=""
                              maxLength={100}
                              value={slicenceNumber}
                              onChange={(event) =>
                                setsLicenceNumber(event.target.value)
                              }
                              onBlur={handleLicenceNumberBlurNew}
                            />
                          )}
                          {sSourceofFish === "2" && (
                            <input
                              type="text"
                              className="form-control"
                              id="slicenceNumber"
                              placeholder=""
                              maxLength={100}
                              value={slicenceNumber}
                              onChange={(event) =>
                                setsLicenceNumber(event.target.value)
                              }
                              onBlur={handleLicenceNumberBlurNew}
                              required
                            />
                          )}
                          <div className="invalid-feedback">
                            Please provide a Licence Number.
                          </div>

                          {!licenceNumberNoShowError && (
                            <div className="error-message">
                              Licence Number does not exists in our records.
                              Please review your information and try again.
                            </div>
                          )}
                          {!uenNoShowError && (
                            <div className="error-message">
                              UEN does not match Licence Number in our records.
                              Please review your information and try again.
                            </div>
                          )}
                        </div>
                      )}
                      {showDragonFish && (
                        <div className="mb-2 ">
                          <label
                            htmlFor="exampleFormControlInput1"
                            className="form-label mb-2"
                          >
                            Premise Code <span className="star">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="spremiseCode"
                            placeholder=""
                            maxLength={100}
                            value={spremiseCode}
                            onChange={(event) =>
                              setsPremiseCode(event.target.value)
                            }
                            onBlur={handlePremiseCodeBlur}
                            required
                          />
                          <div className="invalid-feedback">
                            Please provide premise code.
                          </div>
                          {!premiseCodeNoShowError && (
                            <div className="error-message  mb-3">
                              Premise Code does not exists
                            </div>
                          )}
                          {!batchNumberNoShowError && (
                            <div className="error-message">
                              Batch numbers are not available for the premise
                              code. Please review your information and try
                              again.
                            </div>
                          )}
                          {!premiseCodeHarvestDetailNoShowError && (
                            <div className="error-message">
                              Harvest details are not available for the premise
                              code. Please review your information and try
                              again.
                            </div>
                          )}
                        </div>
                      )}
                      <div className="mb-2 ">
                        <label
                          htmlFor="exampleFormControlInput1"
                          className="form-label mb-2"
                        >
                          Address
                        </label>
                        <div className="row">
                          <div className="col-lg-6">
                            <div className="mb-3 position-relative">
                              <select
                                className="form-select"
                                aria-label="Default select example"
                                id="sorganizationAddress"
                                //placeholder="Address Type"
                                value={sorganizationAddress}
                                onChange={(e) =>
                                  setsOrganizationAddress(e.target.value)
                                }
                                required
                              >
                                <option value="1">Local</option>
                              </select>
                              <span
                                className="star csp-abs-ml-100-mt--30"
                              >
                                *
                              </span>
                              <div className="invalid-feedback mb-3">
                                Please provide an Address.
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="mb-3">
                              <select
                                className="form-select"
                                aria-label="Default select example"
                                id="sorganizationAddress2"
                                value={sorganizationAddress2}
                                onChange={(e) =>
                                  setsOrganizationAddress2(e.target.value)
                                }
                              >
                                <option value="">
                                  Select Type of Premises
                                </option>
                                <option value="1">Cold Room[CR]</option>
                                <option value="2">
                                  Factory and Processing Plant[FPP]
                                </option>
                                <option value="3">Farm[FM]</option>
                                <option value="4">Food Factory[FF]</option>
                                <option value="5">Office[OF]</option>
                                <option value="6">Residential[RE]</option>
                                <option value="7">Retail Outlet[RO]</option>
                                <option value="8">Show Room[SR]</option>
                                <option value="9">Warehouse[WH]</option>
                                <option value="10">FeedMill[FM]</option>
                              </select>
                            </div>
                          </div>

                          <div className="col-lg-6">
                            <div className="mb-3 position-relative">
                              <input
                                type="text"
                                className="form-control"
                                id="sorganizationAddress3"
                                placeholder="Block/House Number"
                                maxLength={15}
                                value={sorganizationAddress3}
                                onChange={blockNoHandler}
                                required
                              />
                              <span
                                className="star csp-abs-ml-100-mt--30"
                              >
                                *
                              </span>

                              <div className="invalid-feedback mb-3">
                                Please provide a Block/House Num.
                              </div>
                              {!blockNoShowError && (
                                <div className="error-message">
                                  Please enter charaters only. eg. "64FB"
                                </div>
                              )}
                            </div>
                          </div>
                          {/* <div className="col-lg-6">
                    <div className="mb-3">
                      <input
                        type="text"
                        className="form-control"
                        id="sorganizationAddress4"
                        placeholder="House Number"
                        maxLength={10}
                        value={sorganizationAddress4}
                        onChange={(event) =>
                          setsOrganizationAddress4(event.target.value)
                        }
                      />
                    </div>
                  </div> */}
                          <div className="col-lg-6">
                            <div className="mb-3">
                              <input
                                type="text"
                                className="form-control"
                                id="sorganizationAddress6"
                                placeholder="Floor Number"
                                pattern="^[a-zA-Z0-9\s]+$"
                                value={sorganizationAddress6}
                                onChange={floorNoHandler}
                                maxLength={3}
                              />
                              {!floorNoShowError && (
                                <div className="error-message  mb-3">
                                  Please enter numbers eg. "123"
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="mb-3 position-relative">
                              <input
                                type="text"
                                className="form-control"
                                id="sorganizationAddress5"
                                placeholder="Street Name"
                                maxLength={64}
                                value={sorganizationAddress5}
                                onChange={(event) =>
                                  setsOrganizationAddress5(event.target.value)
                                }
                                required
                              />
                              <span
                                className="star csp-abs-ml-100-mt--30"
                              >
                                *
                              </span>

                              <div className="invalid-feedback mb-3">
                                Please provide a Street Name.
                              </div>
                            </div>
                          </div>

                          <div className="col-lg-6">
                            <div className="mb-3">
                              <input
                                type="text"
                                className="form-control"
                                id="sorganizationAddress7"
                                placeholder="Unit Number"
                                pattern="^[a-zA-Z0-9\s]+$"
                                value={sorganizationAddress7}
                                onChange={unitNoHandler}
                                maxLength={4}
                              />
                              {!unitNoShowError && (
                                <div className="error-message  mb-3">
                                  Please enter numbers eg. "1234"
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="mb-3 position-relative">
                              <input
                                type="text"
                                className="form-control"
                                id="sorganizationAddress9"
                                placeholder="Postal Code"
                                maxLength={6}
                                pattern="[0-9]+"
                                value={sorganizationAddress9}
                                onChange={postalCodeHandler}
                                required
                              />
                              <span
                                className="star csp-abs-ml-100-mt--30"
                              >
                                *
                              </span>

                              <div className="invalid-feedback mb-3">
                                Please provide a Postal Code.
                              </div>
                              {!postalCodeShowError && (
                                <div className="error-message">
                                  Please enter numbers only. eg. "123456"
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="mb-3">
                              <input
                                type="text"
                                className="form-control"
                                id="sorganizationAddress8"
                                placeholder="Building Name"
                                maxLength={64}
                                value={sorganizationAddress8}
                                onChange={(event) =>
                                  setsOrganizationAddress8(event.target.value)
                                }
                              />
                            </div>
                          </div>

                          <div className="col-lg-6">
                            <div className="mb-3 position-relative">
                              <select
                                className="form-select"
                                aria-label="Default select example"
                                id="sorganizationAddress10"
                                value={sorganizationAddress10}
                                onChange={handleCountryChange}
                                // value={sorganizationAddress10}
                                // onChange={(e) =>
                                //   setsOrganizationAddress10(e.target.value)
                                // }
                                required
                              >
                                {/* {countries.map((option) => {
                          if (
                            option.value ===
                            "561c1d50-093f-ed11-bba3-000d3a081401"
                          ) {
                            return (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                            );
                          }
                          return null; // If the condition is not met, return null to skip this option
                        })} */}
                                {countries.map((option) => (
                                  <option
                                    key={option.value}
                                    value={option.value}
                                  >
                                    {option.label}
                                  </option>
                                ))}
                              </select>
                              <span
                                className="star csp-abs-ml-100-mt--30"
                              >
                                *
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="mb-2">
                        <label
                          htmlFor="exampleFormControlInput1"
                          className="form-label mb-2"
                        >
                          Mobile Number <span className="star">*</span>
                        </label>

                        <div className="input-grp">
                          <select
                            className="form-select"
                            aria-label="Default select example"
                            id="smobilecode"
                            value={smobilecode}
                            onChange={(e) => setsMobileCode(e.target.value)}
                            required
                          >
                            {countryMobileCodes.map((code: any) => (
                              <option key={code} value={code}>
                                {code}
                              </option>
                            ))}
                          </select>
                          <input
                            type="text"
                            aria-describedby="emailHelp"
                            className="form-control"
                            id="smobileNo"
                            placeholder=""
                            pattern="[0-9]+"
                            value={smobileNo}
                            onChange={mobileNoHandler}
                            maxLength={20}
                            required
                          />
                          <div className="invalid-feedback">
                            Please provide a Mobile Number.
                          </div>
                          {!validMobileNo && (
                            <p className="error-message">
                              Invalid mobile no. eg. +6582365355
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="mb-2">
                        <label
                          htmlFor="exampleFormControlInput1"
                          className="form-label mb-2"
                        >
                          Email<span className="star">*</span>
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          id="semail"
                          placeholder=""
                          maxLength={255}
                          value={semail}
                          onChange={handleEmailChange}
                          required
                        />
                        <div className="invalid-feedback">
                          Please provide a Email.
                        </div>
                        {!validEmail && (
                          <p className="error-message">
                            Invalid email format. eg. abc@de.lk
                          </p>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </>
            )}
            {((sSourceofFish && showDragonFish) ||
              showBird ||
              showCrocodile) && (
              <div>
                {!isFromRegistrationLink && (
                  <h2 className="pt-2 pb-0">Application Information</h2>
                )}

                {showBird && !isFromRegistrationLink && (
                  <div className="inst-cnt mt-2">
                    <div className="mb-2">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-2"
                      >
                        Farm CITES Registration Number{" "}
                        {/* <span className="star">*</span>{" "} */}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="sfcRegistrationNo"
                        placeholder=""
                        maxLength={10}
                        value={sfcRegistrationNo}
                        onChange={(event) =>
                          setsFCRegistrationNo(event.target.value)
                        }
                        required
                      />
                      {/* <select
                        className="form-select"
                        aria-label="Default select example"
                        id="sfcRegistrationNo"
                        value={sfcRegistrationNo}
                        onChange={(event) =>
                          setsFCRegistrationNo(event.target.value)
                        }
                        required
                      >
                        <option value=""></option>
                        {fcRegNos.map((option) => (
                          <option key={option.id} value={option.id}>
                            {option.name}
                          </option>
                        ))}
                      </select>
                      <div className="invalid-feedback">
                        Please provide a Farm CITES Registration Number.
                      </div> */}
                    </div>
                    <div className="mb-2">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-2"
                      >
                        Country of Origin <span className="star">*</span>{" "}
                      </label>
                      <select
                        className="form-select"
                        aria-label="Default select example"
                        id="scountryOfOrigin"
                        value={scountryOrigin}
                        onChange={handleCountryOfOriginChange}
                        required
                      >
                        {countries.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="mb-2 ">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-2"
                      >
                        CITES Appendix Number <span className="star">*</span>
                      </label>
                      <select
                        className="form-select"
                        id="scitesAppendixNo"
                        value={scitesAppendixNo}
                        onChange={handleCitesAppendixChange}
                        required
                      >
                        <option value=""></option>
                        <option value={1}>I</option>
                        <option value={2}>II</option>
                        <option value={3}>III</option>
                      </select>
                      <div className="invalid-feedback">
                        Please provide CITES Appendix Number.
                      </div>
                    </div>
                    <div className="mb-2">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-2"
                      >
                        Scientific Name / Common Name{" "}
                        <span className="star">*</span>{" "}
                      </label>
                      {/* <select
                        className="form-select"
                        aria-label="Default select example"
                        id="sscientificName"
                        value={sscientificName}
                        onChange={(e) => setsScientificName(e.target.value)}
                        required
                      >
                        <option value=""></option>
                        <option value="1">
                          Accipiter brevipes / Levant Sparrowhawk
                        </option>
                        <option value="2">
                          Butastur teesa / White-eyed Buzzard
                        </option>
                        <option value="3">
                          Campylopterus falcatus / Lazuline Sabrewing
                        </option>
                        <option value="4">
                          Eos reticulata / Blue-streaked Lory
                        </option>
                        <option value="5">
                          Forpus cyanopygius / Mexican Parrotlet
                        </option>
                      </select> */}
                      <div className="rs-container">
                      <Select<Option,false>
                       classNamePrefix="rs"
                        id="sscientificName"
                        options={scientificNames}                        
                        value={scientificNames.find((o: any) => o.value === sscientificNameString) ?? null}
                        onChange={handleSelect}
                        required
                        isDisabled={disableScientificName}
                        placeholder="Select Scientific Name"                        
                        isSearchable={true}
                        isClearable={false}                       
                        maxMenuHeight={260}
                        menuPlacement="auto"
                        filterOption={(option, inputValue) =>
                          option.label.toLowerCase().includes(inputValue.toLowerCase())
                        }
                      />
                      <div className="invalid-feedback">
                        Please provide a Scientific Name.
                      </div>
                      </div>
                    </div>
                    {/* <div className="mb-2">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-2"
                      >
                        Length of Fish <span className="star">*</span>{" "}
                      </label>
                      <select
                        className="form-select"
                        aria-label="Default select example"
                        id="sLengthofFish"
                        value={sLengthofFish}
                        onChange={(e) =>
                          setsLengthofFish(Number(e.target.value))
                        }
                        required
                      >
                        <option value=""></option>
                        <option value={1}>12-15cm</option>
                        <option value={2}>15-20cm</option>
                        <option value={3}>More than 20cm</option>
                      </select>
                      <div className="invalid-feedback">
                        Please provide a Length of Fish.
                      </div>
                    </div> */}

                    <div className="mb-2 ">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-2"
                      >
                        Foreign CITES Permit Number{" "}
                        {scountryOrigin !== defaultCountryId && (
                          <span className="star">*</span>
                        )}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="sforeignCITESPermitNo"
                        placeholder=""
                        value={sforeignCITESPermitNo}
                        onChange={(event) =>
                          setsForeignCITESPermitNo(event.target.value)
                        }
                        required={scountryOrigin !== defaultCountryId}
                      />
                      <div className="invalid-feedback">
                        Please provide a Foreign CITES Permit Number.
                      </div>
                    </div>
                    <div className="mb-2 ">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-2"
                      >
                        Farm Code
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="sbulkFarmCode"
                        placeholder=""
                        value={sbulkFarmCode}
                        onChange={(event) =>
                          setsbulkFarmCode(event.target.value)
                        }
                      />
                    </div>
                    {/* <div className="mb-2">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-2"
                      >
                        Hatch date
                        {scountryOrigin === defaultCountryId && (
                          <span className="star">*</span>
                        )}
                      </label>                      
                      <DatePicker
                        id="sHatchDate"
                        selected={sHatchDate}
                        onChange={(date) => setHatchDate(date)}
                        className="form-control"
                        wrapperClassName="w-100"
                        maxDate={new Date()}
                        showIcon
                        placeholderText="dd/mm/yyyy"
                        dateFormat="dd/MM/yyyy"
                        filterDate={(date) =>
                          !isWeekend(date) && !isHoliday(date)
                        }
                        required={scountryOrigin === defaultCountryId}
                      />
                      <div className="invalid-feedback">
                        Please provide Hatch Date.
                      </div>
                      {!isValidDate && (
                        <p className="error-message">
                          Hatch Date cannot be later than today's date.
                        </p>
                      )}
                    </div> */}
                  </div>
                )}
                {showCrocodile && (
                  <div className="inst-cnt mt-4">
                    <div className="mb-2">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-2"
                      >
                        Type of Tag <span className="star">*</span>{" "}
                      </label>
                      <select
                        className="form-select"
                        id="sTypeofTag"
                        value={sTypeofTag}
                        onChange={(e) => setsTypeofTag(Number(e.target.value))}
                        required
                      >
                        <option value=""></option>
                        <option value={1}>Original</option>
                        <option value={2}>Re-Tag</option>
                      </select>
                      <div className="invalid-feedback">
                        Please provide a Type of Tag.
                      </div>
                    </div>
                    <div className="mb-2">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-2"
                      >
                        Country of Origin <span className="star">*</span>{" "}
                      </label>
                      <select
                        className="form-select"
                        aria-label="Default select example"
                        id="scountryOfOrigin"
                        value={scountryOrigin}
                        onChange={handleCountryOfOriginChange}
                        required
                      >
                        {countries.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="mb-2">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-2"
                      >
                        CITES Appendix Number <span className="star">*</span>
                      </label>
                      <select
                        className="form-select"
                        id="scitesAppendixNo"
                        value={scitesAppendixNo}
                        onChange={handleCitesAppendixChange}
                        required
                      >
                        <option value=""></option>
                        <option value={1}>I</option>
                        <option value={2}>II</option>
                        <option value={3}>III</option>
                      </select>
                      <div className="invalid-feedback">
                        Please provide CITES Appendix Number.
                      </div>
                    </div>
                    <div className="mb-2">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-2"
                      >
                        Scientific Name / Common Name{" "}
                        <span className="star">*</span>{" "}
                      </label>
                      {/* <select
                        className="form-select"
                        aria-label="Default select example"
                        id="sscientificName"
                        value={sscientificName}
                        onChange={(e) => setsScientificName(e.target.value)}
                        required
                      >
                        <option value=""></option>
                        <option value="1">
                          Caiman latirostris / Brazilian caiman
                        </option>
                        <option value="2">
                          Crocodylus rhombifer / Cuban Crocodile
                        </option>
                        <option value="3">
                          Osteolaemus tetraspis / West African Dwarf Crocodile
                        </option>
                      </select> */}
                      <div className="rs-container">
                      <Select<Option,false>
                       classNamePrefix="rs"
                        id="sscientificName"
                        options={scientificNames}                        
                        value={scientificNames.find((o: any) => o.value === sscientificNameString) ?? null}
                        onChange={handleSelect}
                        required
                        isDisabled={disableScientificName}
                        placeholder="Select Scientific Name"                        
                        isSearchable={true}
                        isClearable={false}                       
                        maxMenuHeight={260}
                        menuPlacement="auto"
                        filterOption={(option, inputValue) =>
                          option.label.toLowerCase().includes(inputValue.toLowerCase())
                        }
                      />
                      <div className="invalid-feedback">
                        Please provide a Scientific Name.
                      </div>
                      </div>
                    </div>

                    <div className="mb-2">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-2"
                      >
                        Foreign CITES Permit Number{" "}
                        {scountryOrigin !== defaultCountryId && (
                          <span className="star">*</span>
                        )}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="sforeignCITESPermitNo"
                        placeholder=""
                        value={sforeignCITESPermitNo}
                        onChange={(event) =>
                          setsForeignCITESPermitNo(event.target.value)
                        }
                        required={scountryOrigin !== defaultCountryId}
                      />
                      <div className="invalid-feedback">
                        Please provide a Foreign CITES Permit Number.
                      </div>
                    </div>
                  </div>
                )}
                {showDragonFish && !isFromRegistrationLink && (
                  <div className="inst-cnt mt-2">
                    <div className="mb-2">
                      {sSourceofFish === "1" && (
                        <label
                          htmlFor="exampleFormControlInput1"
                          className="form-label mb-2"
                        >
                          Farm CITES Registration Number{" "}
                        </label>
                      )}
                      {sSourceofFish === "2" && (
                        <label
                          htmlFor="exampleFormControlInput1"
                          className="form-label mb-2"
                        >
                          Farm CITES Registration Number{" "}
                          <span className="star">*</span>{" "}
                        </label>
                      )}
                      {/* <input
                        type="text"
                        className="form-control"
                        id="sfcRegistrationNo"
                        placeholder=""
                        maxLength={10}
                        value={sfcRegistrationNo}
                        onChange={(event) =>
                          setsFCRegistrationNo(event.target.value)
                        }
                        required
                      /> */}
                      <select
                        className="form-select"
                        aria-label="Default select example"
                        id="sfcRegistrationNo"
                        value={sfcRegistrationNo}
                        onChange={(event) =>
                          setsFCRegistrationNo(event.target.value)
                        }
                      >
                        <option value=""></option>
                        {fcRegNos.map((option) => (
                          <option key={option.id} value={option.id}>
                            {option.name}
                          </option>
                        ))}
                      </select>
                      <div className="invalid-feedback">
                        Please provide a Farm CITES Registration Number.
                      </div>
                    </div>

                    <div className="mb-2">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-2"
                      >
                        Country of Origin <span className="star">*</span>{" "}
                      </label>
                      <select
                        className="form-select"
                        aria-label="Default select example"
                        id="scountryOfOrigin"
                        value={scountryOrigin}
                        onChange={handleCountryOfOriginChange}
                        required
                      >
                        {sSourceofFish === "1" &&
                          countries.map(
                            (option) =>
                              option.label === "Singapore" && (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              )
                          )}
                        {sSourceofFish === "2" &&
                          countries.map(
                            (option) =>
                              option.label !== "Singapore" && (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              )
                          )}
                      </select>
                    </div>
                    <div className="mb-2">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-2"
                      >
                        Scientific Name / Common Name{" "}
                        <span className="star">*</span>{" "}
                      </label>

                      <div className="rs-container">
                      <Select<Option,false>
                       classNamePrefix="rs"
                        id="sscientificName"
                        options={scientificNames}                        
                        value={scientificNames.find((o: any) => o.value === sscientificNameString) ?? null}
                        onChange={handleSelect}
                        required
                        isDisabled={disableScientificName}
                        placeholder="Select Scientific Name"                        
                        isSearchable={true}
                        isClearable={false}                       
                        maxMenuHeight={260}
                        menuPlacement="auto"
                        filterOption={(option, inputValue) =>
                          option.label.toLowerCase().includes(inputValue.toLowerCase())
                        }
                      />
                      <div className="invalid-feedback">
                        Please provide a Scientific Name.
                      </div>
                      </div>
                    </div>
                    {sSourceofFish === "1" && (
                      <div className="mb-2">
                        <label
                          htmlFor="exampleFormControlInput1"
                          className="form-label mb-2"
                        >
                          Length of Fish <span className="star">*</span>{" "}
                        </label>
                        <select
                          className="form-select"
                          aria-label="Default select example"
                          id="sLengthofFish"
                          value={sLengthofFish}
                          onChange={(e) =>
                            setsLengthofFish(Number(e.target.value))
                          }
                          required
                        >
                          <option value=""></option>
                          <option value={1}>12-15cm</option>
                          <option value={2}>16-20cm</option>
                          <option value={3}>More than 20cm</option>
                        </select>
                        <div className="invalid-feedback">
                          Please provide a Length of Fish.
                        </div>
                      </div>
                    )}
                    {sSourceofFish === "2" && (
                      <div>
                        <div className="mb-2 ">
                          <label
                            htmlFor="exampleFormControlInput1"
                            className="form-label mb-2"
                          >
                            CITES Appendix Number{" "}
                            <span className="star">*</span>
                          </label>
                          <select
                            className="form-select"
                            id="scitesAppendixNo"
                            value={scitesAppendixNo}
                            onChange={(e) =>
                              setsCitesAppendixNo(Number(e.target.value))
                            }
                            required
                          >
                            <option value={1}>I</option>
                          </select>
                        </div>

                        <div className="mb-2 ">
                          <label
                            htmlFor="exampleFormControlInput1"
                            className="form-label mb-2"
                          >
                            Foreign CITES Permit Number{" "}
                            {scountryOrigin !== defaultCountryId && (
                              <span className="star">*</span>
                            )}
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="sforeignCITESPermitNo"
                            placeholder=""
                            value={sforeignCITESPermitNo}
                            onChange={(event) =>
                              setsForeignCITESPermitNo(event.target.value)
                            }
                            required={scountryOrigin !== defaultCountryId}
                          />
                          <div className="invalid-feedback">
                            Please provide a Foreign CITES Permit Number.
                          </div>
                        </div>
                      </div>
                    )}
                    {sSourceofFish === "1" && (
                      <div>
                        <div className="mb-2 ">
                          <label
                            htmlFor="exampleFormControlInput1"
                            className="form-label mb-2"
                          >
                            Batch Number <span className="star">*</span>
                          </label>
                          <select
                            className="form-select"
                            aria-label="Default select example"
                            id="sBatchNumber"
                            value={sBatchNumber}
                            onChange={handleBatchNumberChange}
                            // value={sorganizationAddress10}
                            // onChange={(e) =>
                            //   setsOrganizationAddress10(e.target.value)
                            // }
                            required
                          >
                            <option value="">-- Select Batch Number --</option>
                            {batchNumbers.map((option) => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                            ))}
                          </select>
                          <div className="invalid-feedback">
                            Please select a Batch Number.
                          </div>
                        </div>
                        <div className="mb-2 ">
                          <label
                            htmlFor="exampleFormControlInput1"
                            className="form-label mb-2"
                          >
                            Remaining Quantity of Fish in Batch{" "}
                            <span className="star">*</span>
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            id="sRegisteredQuantityinBatch"
                            maxLength={10}
                            placeholder=""
                            value={sRegisteredQuantityinBatch}
                            onChange={(event) =>
                              setsRegisteredQuantityinBatch(
                                Number(event.target.value)
                              )
                            }
                            required
                            disabled
                          />
                          <div className="invalid-feedback">
                            Please provide a Remaining Quantity of Fish in
                            Batch.
                          </div>
                        </div>
                        <div className="mb-2 ">
                          <label
                            htmlFor="exampleFormControlInput1"
                            className="form-label mb-2"
                          >
                            Harvest Date <span className="star">*</span>
                          </label>
                          <DatePicker
                            id="sHarvestDate"
                            selected={sHarvestDate}
                            onChange={(date: Date | null) => setsHarvestDate(date)}
                            className="form-control"
                            wrapperClassName="w-100"
                            minDate={minDate}
                            showIcon
                            placeholderText="dd/mm/yyyy"
                            dateFormat="dd/MM/yyyy"
                            filterDate={(date) =>
                              !isWeekend(date) && !isHoliday(date)
                            }
                            required
                            disabled
                          />
                          <div className="invalid-feedback">
                            Please provide a Harvest Date.
                          </div>
                        </div>
                        {sSourceofFish === "1" && (
                          <div className="mb-2">
                            <label
                              htmlFor="exampleFormControlInput1"
                              className="form-label mb-2"
                            >
                              Variety of Fish <span className="star">*</span>{" "}
                            </label>
                            <select
                              className="form-select"
                              id="sVarietyofFish"
                              value={sVarietyofFish}
                              onChange={(e) =>
                                setsVarietyofFish(Number(e.target.value))
                              }
                              required
                              disabled
                            >
                              <option value=""></option>
                              <option value={1}>Red</option>
                              <option value={2}>Gold</option>
                              <option value={3}>Green</option>
                            </select>
                            <div className="invalid-feedback">
                              Please provide a Variety of Fish.
                            </div>
                          </div>
                        )}
                        <div className="mb-2 ">
                          <label
                            htmlFor="exampleFormControlInput1"
                            className="form-label mb-2"
                          >
                            Parent Microchip <span className="star">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="sParentMicrochip"
                            placeholder=""
                            value={sParentMicrochip}
                            maxLength={16}
                            onChange={(event) =>
                              setsParentMicrochip(event.target.value)
                            }
                            required
                            disabled
                          />
                          <div className="invalid-feedback">
                            Please provide a Parent Microchip.
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="mb-2 ">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-2"
                      >
                        Remarks{" "}
                        {!showDragonFish && <span className="star">*</span>}
                      </label>
                      {/* <input
                        type="text"
                        className="form-control"
                        id="sRemarks"
                        placeholder=""
                        maxLength={60}
                        value={sRemarks}
                        onChange={(event) => setsRemarks(event.target.value)}
                        required={!showDragonFish}
                      /> */}
                      <textarea
                        rows={3}
                        className="form-control"
                        id="sRemarks"
                        placeholder=""
                        maxLength={1000}
                        value={sRemarks}
                        onChange={(event) => setsRemarks(event.target.value)}
                        required={!showDragonFish}
                      ></textarea>
                      <div className="invalid-feedback">
                        Please provide a Remarks.
                      </div>
                    </div>
                  </div>
                )}

                <h2>Declaration</h2>
                <div className="inst-cnt mb-2">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={checkboxChecked}
                      onChange={handleCheckboxChange}
                      id="flexCheckDefault"
                      required
                    />
                    <label className="" htmlFor="flexCheckDefault">
                      I / We, the exporter, confirm that the animal / products
                      are marked with the following seamless numbered leg rings,
                      tags, or scannable microchips.
                    </label>
                    <div className="invalid-feedback">
                      Please confirm the declaration checkbox
                    </div>
                    {submitted && !checkboxChecked && (
                      <p className="error-message">
                        Please confirm the declaration checkbox
                      </p>
                    )}
                  </div>
                </div>
                <div className="mb-3">
                  <ReCAPTCHA
                    ref={recaptchaRef}
                    sitekey={site_Key}
                    onChange={() => setIsCaptchaValid(true)}
                    onExpired={() => setIsCaptchaValid(false)}
                  />
                  {submitted && !isCaptchaValid && (
                    <div className="error-message">
                      Please complete the reCAPTCHA verification.
                    </div>
                  )}
                </div>
                {isFromRegistrationLink && (
                  <div className="inst-cnt mt-2">
                    <div className="mt-2">
                      <label htmlFor="file-upload" className="form-label">
                        Upload Excel File
                        <span
                          className="csp-ml-5"
                          onMouseEnter={handleMouseEnter}
                          onMouseLeave={handleMouseLeave}
                          title="Documents allowed: .xlsx, .xls."
                        >
                          <FontAwesomeIcon icon={faInfoCircle} />
                        </span>
                      </label>
                      <div className="d-flex align-items-center gap-2">
                        <input
                          type="file"
                          id="file-upload"
                          className="form-control"
                          accept=".xls, .xlsx"
                          onChange={handleFileChange}
                        />
                        <button
                          type="button"
                          className="btn btn-success"
                          onClick={handleUpload}
                          disabled={!selectedFile}
                        >
                          Upload
                        </button>
                      </div>
                    </div>

                    {selectedFile && (
                      <div className="mt-2">
                        <strong>Selected File:</strong> {selectedFile.name}
                      </div>
                    )}
                  </div>
                )}
                <div className="row mt-4">
                  <div className="col-lg-3">
                    <button
                      type="button"
                      className="btn btn-success w-100"
                      disabled={disableSubmit}
                      onClick={handleDownload}
                    >
                       {isFromRegistrationLink ? "Download Template" :"Download Form" }
                    </button>
                  </div>
                </div>
              </div>
            )}
            {showUpload && <Upload data={inputData}></Upload>}
            {/* {submitted && !validEmail && (
              <p className="error-message">Invalid email format</p>
            )} */}
            {/* {submitted && !checkboxChecked && (
              <p className="invalid-feedback">
                Please confirm the declaration checkbox
              </p>
            )} */}
            {/* {submitted && !salutationSelected && (
              <p className="error-message">Please select salutation</p>
            )} */}

            {errorMessage && <p>{errorMessage}</p>}
          </div>
        )}
      </form>
    </>
  );
};

export default TabPhillProfile;
